import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  AccessTimeOutlined,
  Add,
  CreditCardOutlined,
  InfoOutlined,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  ReceiptLongOutlined,
  EventNoteOutlined,
  ScheduleOutlined,
  CalendarViewWeekOutlined,
  CancelOutlined,
  CategoryOutlined,
} from "@mui/icons-material";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

import messages from "../../../../assets/locale/messages";
import { getCurranciesRequest } from "../../../../store/LookUps/actions";
import {
  getServicesRequest,
  getServicesResponse,
} from "../../../../store/Services/actions";
import {
  getSpecialtiesRequest,
  getSpecialtiesResponse,
} from "../../../../store/Specialties/actions";
import {
  deleteBranchServiceRequest,
  deleteBranchSpecialtyRequest,
  getDeleteBranchSpecialityStatusRequest,
  getDeleteBranchServiceStatusRequest,
  editBranchRequest,
  editBranchServicesRequest,
  getBranchRequest,
  getBranchResponse,
  getBranchServicesRequest,
  getBranchServicesResponse,
  getRequestStatus,
  getPublishBranchServiceRequestStatus,
} from "../../../../store/Branches/actions";
import Modal from "../../../../components/Modal";
import Input from "../../../../components/Input";
import Switch from "../../../../components/Switch";
import Select from "../../../../components/Select";
import Button from "../../../../components/Button";
import Checkbox from "../../../../components/Checkbox";
import Accordion from "../../../../components/Accordion";
import EmptyState from "../../../../components/EmptyState";
import { EditBgIcon } from "../../../../utils/Icons/EditBg";
import {
  ONE_NUMBERS_ONLY,
  POSITIVE_TWO_DICIMAL_ONLY,
  ONLY_ENGLISH_SPACE_DOT_COMMA_SEMICOLON,
  ONLY_ARABIC_SPACE_DOT_COMMA_SEMICOLON,
  NUMBERS_REGEX,
} from "../../../../utils/Patterns";
import { DeleteBgIcon } from "../../../../utils/Icons/DeleteBg";
import "./AddServicesDetails.scss";
import { getGoogleMapsPolygon } from "../../../../store/GoogleMapCoords/actions";
import { ROUTE_PATHS } from "../../../../utils/RoutesPaths";
import { renderTextEllipsis } from "../../../../utils/Helpers";
import Tooltip from "../../../../components/Tooltip";
import AddEditManualSpecialtyModal from "./ManualSpecialtyOrServiceManagment/AddEditManualSpecialtyModal";
import DeleteManualAddedSpecialtyModal from "./ManualSpecialtyOrServiceManagment/DeleteManualAddedSpecialtyModal";
import AddEditManualServiceModal from "./ManualSpecialtyOrServiceManagment/AddEditManualServiceModal";
import DeleteManualAddedServiceModal from "./ManualSpecialtyOrServiceManagment/DeleteManualAddedServiceModal";

const AddServicesDetails = ({
  changeSubTitle,
  renderList,
  changeServiceTitle,
  proceedToNextStep,
  btnClicked,
  ressetBtnClicked,
  backToPrevStep,
  parentProps,
  removeMainAddBtn,
  setBtnClicked,
}) => {
  const lang = useSelector((state) => state.locale.lang);
  const { branches, shared, inputsValidations } = messages[lang];
  const history = useHistory();
  const { providerid } = useParams();
  const { branchid } = useParams();
  const dispatch = useDispatch();
  const specialtiesList = useSelector((state) => state.specialties.list);
  const isLoading = useSelector((state) => state.loader);
  const serviceslist = useSelector((state) => state.services.list);
  const currencyOptions = useSelector((state) => state.lookUps.currancies);
  const createdBranch = useSelector((state) => state.branches.addedBranch);
  const viewBranchDetails = useSelector(
    (state) => state.branches.branchDetails
  ); // get branch detauls by id original BE data
  const branchServicesList = useSelector(
    (state) => state.branches.branchServices
  );
  const requestStatus = useSelector((state) => state.branches.requestStatus);
  const publishBranchServiceStatusRequest = useSelector(
    (state) => state.branches.publishBranchServiceStatusRequest
  );
  const deleteBranchServiceStatusRequest = useSelector(
    (state) => state.branches.deleteBranchServiceStatusRequest
  );
  const deleteBranchSpecialityStatusRequest = useSelector(
    (state) => state.branches.deleteBranchSpecialityStatusRequest
  );
  const savedBranchCreatedId = useSelector(
    (state) => state.branches.branchCreatedId
  );
  const [mappedServices, setMappedServices] = useState([]);
  const [nativeServices, setNativeServices] = useState(null);
  const [deleteServiceId, setdeleteServiceId] = useState(null);
  const [deleteSpecialtyId, setdeleteSpecialtyId] = useState(null);
  const [choosenSpecialtyId, setChoosenSpecialtyId] = useState(null);
  const [currencyOptionsList, setCurrencyOptionsList] = useState(null);
  const [renderServicesSection, setRenderServicesSection] = useState(false);
  const [showLeaveWarningModal, setShowLeaveWarningModal] = useState(false);
  const [renderEmpatyStateSection, setRenderEmpatyStateSection] =
    useState(false);
  const [renderAddedServiceSection, setRenderAddedServiceSection] =
    useState(false);
  const [renderSpecialtiesSection, setRenderSpecialtiesSection] =
    useState(false);
  const [openDeleteSpecilatyConfirm, setOpenDeleteSepecialtyConfirm] =
    useState(false);
  const [openDeleteServiceConfirm, setOpenDeleteServiceConfirm] =
    useState(false);
  const [addedSepacialtyWithServices, setAddedSepacialtyWithServices] =
    useState(null);
  const [
    noAssgiendServicesOnSpecialtyAlert,
    setNoAssgiendServicesOnSpecialtyAlert,
  ] = useState(false);
  const [serviceTitle, setServiceTitle] = useState(null);
  const [
    isAddSpecialtiesAndServicesBTNClicked,
    setIsAddSpecialtiesAndServicesBTNClicked,
  ] = useState(false);
  const [servicesStatus, setServicesStatus] = useState([]);
  const [showDeactivateServicePopup, setShowDeactivateServicePopup] =
    useState(false);
  const [deactivatedService, setDeactivatedService] = useState({});
  const [openDoneModal, setOpenDoneModal] = useState(false);
  const [showAddEditManualSpecialtyModal, setShowAddEditManualSpecialtyModal] =
    useState(false);
  const [selectedManualAddedSpecialty, setSelectedManualAddedSpecialty] =
    useState(null);
  const [
    showDeleteManualAddedSpecialtyModal,
    setShowDeleteManualAddedSpecialtyModal,
  ] = useState(false);
  const [showAddEditManualServiceModal, setShowAddEditManualServiceModal] =
    useState(false);
  const [selectedManualAddedService, setSelectedManualAddedService] =
    useState(null);
  const [
    showDeleteManualAddedServiceModal,
    setShowDeleteManualAddedServiceModal,
  ] = useState(false);
  const [branchCategoryId, setBranchCategoryId] = useState(null);
  const [allowMultiSessions, setAllowMultiSessions] = useState(false);
  const [serviceProviderId, setServiceProviderId] = useState(null);
  const branchCreatedId =
    savedBranchCreatedId || history.location?.state?.branchCreatedId;


  const setActiveSection = (section) => {
    setRenderEmpatyStateSection(section === "empty");
    setRenderSpecialtiesSection(section === "specialties");
    setRenderServicesSection(section === "services");
    setRenderAddedServiceSection(section === "added");
  };

  useEffect(() => {
    dispatch(getCurranciesRequest());
    // dispatch(getSpecialtiesResponse([]));
    dispatch(getRequestStatus(null));
    dispatch(getGoogleMapsPolygon([]));
  }, []);

  useEffect(() => {
    return () => {
      dispatch(getSpecialtiesResponse([]));
    };
  }, []);

  useEffect(() => {
    if (publishBranchServiceStatusRequest != null) {
      dispatch(
        getBranchServicesRequest({
          page: -1,
          branch_id: viewBranchDetails?.id,
        })
      );
    }
    dispatch(getPublishBranchServiceRequestStatus(null));
  }, [publishBranchServiceStatusRequest]);

  useEffect(() => {
    if (deleteBranchServiceStatusRequest) {
      dispatch(
        getBranchServicesRequest({
          page: -1,
          branch_id: viewBranchDetails?.id,
        })
      );
      dispatch(
        getBranchRequest(
          branchCreatedId || parentProps?.location?.state?.branchDataToEdit?.id
        )
      );
    }
  }, [deleteBranchServiceStatusRequest]);

  useEffect(() => {
    if (deleteBranchSpecialityStatusRequest) {
      dispatch(
        getBranchRequest(
          branchCreatedId || parentProps?.location?.state?.branchDataToEdit?.id
        )
      );
    }
  }, [deleteBranchSpecialityStatusRequest]);

  const errorss = [
    {
      errorTitle: "currencyIsRequired",
      errorMessaged:
        branches.addBranch.specialtiesAndServices.currencyIsRequired,
    },
    {
      errorTitle: "onlyNumbersAreAllowed",
      errorMessaged:
        branches.addBranch.specialtiesAndServices.onlyNumbersAreAllowed,
    },
    {
      errorTitle: "fromIsRequired",
      errorMessaged: branches.addBranch.specialtiesAndServices.fromIsRequired,
    },
    {
      errorTitle: "durationIsRequired",
      errorMessaged:
        branches.addBranch.specialtiesAndServices.durationIsRequired,
    },
    {
      errorTitle: "durationCanNotBeLessThanOne",
      errorMessaged:
        branches.addBranch.specialtiesAndServices.durationCanNotBeLessThanOne,
    },
    {
      errorTitle: "onlyEnglishSpaceDotCommaSemicolon",
      errorMessaged:
        branches.addBranch.specialtiesAndServices
          .onlyEnglishSpaceDotCommaSemicolon,
    },
    {
      errorTitle: "onlyArabicSpaceDotCommaSemicolon",
      errorMessaged:
        branches.addBranch.specialtiesAndServices
          .onlyArabicSpaceDotCommaSemicolon,
    },
  ];

  useEffect(() => {
    if (currencyOptions?.length > 0) {
      let mappedCurrencyOptions = currencyOptions.map((item) => {
        return {
          // add space before name_ar as select component crop first letter in local ar
          label: lang === "en" ? item.name_en : ` ${item.name_ar}`,
          value: item.id,
          id: item.id,
        };
      });
      setCurrencyOptionsList(mappedCurrencyOptions);
    }
  }, [currencyOptions, lang]);

  useEffect(() => {
    if (renderServicesSection && choosenSpecialtyId !== null) {
      getServicesBySpecialtyId(choosenSpecialtyId);
    }
  }, [choosenSpecialtyId, renderServicesSection]);

  useEffect(() => {
    if (renderAddedServiceSection) {
      dispatch(
        getBranchRequest(
          branchCreatedId || parentProps?.location?.state?.branchDataToEdit?.id
        )
      );
    }
  }, [renderAddedServiceSection]);

  useEffect(() => {
    setTimeout(() => {
      renderServicesContent();
    }, 500);
  }, [
    viewBranchDetails,
    choosenSpecialtyId,
    renderServicesSection,
    serviceslist,
  ]);

  useEffect(() => {
    assignAddedSpecialtyAndServicesFromViewBranchData();
    // Store category ID when viewBranchDetails is available
    if (viewBranchDetails?.category?.id) {
      setBranchCategoryId(viewBranchDetails.category.id);
    }
    // Set allowMultiSessions only when viewBranchDetails has valid category data
    // Don't reset to false if data is temporarily unavailable (preserve existing value)
    if (viewBranchDetails?.category?.is_multi_session_allowed !== undefined) {
      setAllowMultiSessions(viewBranchDetails.category.is_multi_session_allowed || false);
      setServiceProviderId(viewBranchDetails.service_provider.id);
    }
  }, [lang, viewBranchDetails]);
console.log("allowMultiSessions", allowMultiSessions);

  useEffect(() => {
    checkSetctionToRender();
  }, [viewBranchDetails]);

  // to update accordion
  useEffect(() => {
    // TODO: add branch service list to depandanced array
    updateAccordionData();
  }, [
    branchServicesList,
    currencyOptionsList,
    lang,
    deleteServiceId,
    serviceslist,
    publishBranchServiceStatusRequest,
  ]);

  useEffect(() => {
    if (specialtiesList?.length > 0) {
      checkSetctionToRender();
      setIsAddSpecialtiesAndServicesBTNClicked(false);
    } else {
      if (isAddSpecialtiesAndServicesBTNClicked) {
        setRenderSpecialtiesSection(true);
        setRenderEmpatyStateSection(false);
      }
    }
  }, [specialtiesList]);

  useEffect(() => {
    if (
      addedSepacialtyWithServices?.length > 0 &&
      specialtiesList?.length > 0
    ) {
      setAddedSepacialtyWithServices(
        addedSepacialtyWithServices?.map((specialty) => {
          specialtiesList?.forEach((item) => {
            if (item.title === specialty.specialtyName) {
              specialty.realSpecialtyId = item.id;
            }
          });
          return specialty;
        })
      );
    }
  }, [specialtiesList]);

  useEffect(() => {
    if (renderServicesSection || renderSpecialtiesSection) {
      if (serviceTitle) {
        changeServiceTitle(
          lang === "en" ? serviceTitle.name_en : serviceTitle.name_ar
        );
      }
    }
  }, [lang, renderServicesSection]);

  useEffect(() => {
    if (btnClicked) {
      checkSectionToRenderBtnClicked();
      setTimeout(() => {
        ressetBtnClicked();
      }, 1000);
    }
  }, [btnClicked]);

  useEffect(() => {
    removeMainAddBtn(renderEmpatyStateSection);
  }, [renderEmpatyStateSection]);

  useEffect(() => {
    showAddedServicesAfterSave();
  }, [requestStatus]);

  useEffect(() => {
    if (addedSepacialtyWithServices?.length === 0) {
      removeMainAddBtn(true);
    } else {
      removeMainAddBtn(false);
    }
  }, [addedSepacialtyWithServices]);

  const handleToggleButtonValue = (serviceId) => {
    const targetService = servicesStatus.find(
      (service) => service.service_id === serviceId
    );
    return targetService?.isPublished;
  };

  const handleActivateOrDeactivateService = (service) => {
    dispatch(
      editBranchServicesRequest({
        id: service.id,
        data: {
          status: handleToggleButtonValue(service.service_id)
            ? "unpublished"
            : "published",
        },
      })
    );
    setAddedSepacialtyWithServices(
      addedSepacialtyWithServices.map((specialty) => {
        specialty.services?.map((mappedService) => {
          if (mappedService.id === service?.id) {
            service.status = handleToggleButtonValue(service.service_id)
              ? "unpublished"
              : "published";
          }
          return mappedService;
        });
        return specialty;
      })
    );
  };

  const handleConfirmDecativateService = () => {
    handleActivateOrDeactivateService(deactivatedService);
    handleCloseDeactivatePopup();
  };

  const handleCloseDeactivatePopup = () => {
    setShowDeactivateServicePopup(false);
    setDeactivatedService({});
  };

  const assignAddedSpecialtyAndServicesFromViewBranchData = () => {
    let mappedarray = [];
    if (viewBranchDetails?.specialties?.length > 0) {
      viewBranchDetails.specialties?.map((item) => {
        let specialty = {
          id: null,
          specialtyName: "",
          isExpanded: false,
          realSpecialtyId: null,
          services: [],
        };
        specialty = {
          ...specialty,
          id: item.id,
          specialtyName:
            lang === "en" ? item.specialty_title_en : item.specialty_title_ar,
          title_en: item.specialty_title_en,
          title_ar: item.specialty_title_ar,
          realSpecialtyId: item.specialty_id,
        };
        mappedarray.push(specialty);
        return item;
      });
    }
    setAddedSepacialtyWithServices(mappedarray);
  };
  const updateAccordionData = () => {
    if (branchServicesList?.length > 0) {
      const branchServiceStatus = branchServicesList.map((service) => {
        return {
          service_id: service.service_id,
          isPublished: service.status === "published" ? true : false,
        };
      });
      setServicesStatus(branchServiceStatus);
      let newAddedSepacialtyWithServices = addedSepacialtyWithServices?.map(
        (specialty) => {
          let services = branchServicesList?.filter(
            (branchService) =>
              branchService.branch_specialty_id === specialty.id
          );
          if (services?.length > 0) {
            services?.forEach((singleService) => {
              let service = {
                id: singleService.id,
                service_id: singleService.service_id,
                name_en: singleService.title_en,
                name_ar: singleService.title_ar,
                service_type: singleService.service_type || "single_service",
                sessions_count: singleService.sessions_count || "",
                expiry_weeks: singleService.expiry_weeks || "",
                schedule_type: singleService.schedule_type || null,
                cancellation_window_hours: singleService.cancellation_window_hours || "",
                // inline validation error keys (mapped to same keys used in AddEditManualServiceModal)
                sessionsCountError: "",
                expiryWeeksError: "",
                cancellationWindowHoursError: "",
                scheduleTypeError: "",
                details: {
                  feesRange: {
                    from: singleService.fees_from,
                    to: singleService.fees_to,
                    hasErrors: false,
                    errors: [],
                  },
                  currency: currencyOptionsList?.find(
                    (currency) =>
                      currency.id === singleService.currency_id ||
                      currency.id === 1
                  ),
                  duration: singleService.duration_mins,
                  // description: lang === 'en' ? singleService.description_en : singleService.description_ar,
                  descriptionEN: {
                    value: singleService.description_en,
                    hasErrors: false,
                    errors: [],
                  },
                  descriptionAR: {
                    value: singleService.description_ar,
                    hasErrors: false,
                    errors: [],
                  },
                  hasErrors: false,
                  errors: [],
                },
                _destroy: false,
                editMood: false,
                isActive: singleService.is_active,
              };
              if (specialty.id === singleService.branch_specialty_id) {
                if (specialty.services?.length === 0) {
                  specialty.services.push(service);
                } else {
                  let isServiceExists = specialty.services?.findIndex(
                    (item) => item.id === singleService.id
                  );
                  if (isServiceExists === -1) {
                    specialty.services.push(service);
                  }
                }
              }
            });
          }
          return specialty;
        }
      );
      setAddedSepacialtyWithServices(newAddedSepacialtyWithServices);
    }
  };

  const clearServicesState = () => {
    dispatch(getServicesResponse({ list: [] }));
  };

  const {
    values,
    setFieldValue,
    setValues,
    handleSubmit,
    touched,
    errors,
    setFieldTouched,
    dirty,
    isValid,
    resetForm,
  } = useFormik({
    initialValues: {
      choosenServices: [],
    },
    validationSchema: Yup.object({
      choosenServices: Yup.array().of(
        Yup.object().shape({
          serviceId: Yup.number(),
          details: Yup.object().shape({
            feesRange: Yup.object().shape({
              from: Yup.number(),
              to: Yup.number(),
            }),
            currency: Yup.object().shape({
              label: Yup.string(),
              value: Yup.number(),
              id: Yup.number(),
            }),
            duration: Yup.number(),
            // description: Yup.string(),
            descriptionEN: Yup.string(),
            descriptionAR: Yup.string(),
          }),
        })
      ),
    }),
    onSubmit: (obj) => {},
  });

  const checkSetctionToRender = () => {
    if (!btnClicked) {
      if (viewBranchDetails) {
        if (viewBranchDetails?.specialties?.length > 0) {
          setActiveSection("added");
          changeSubTitle(null);
        } else {
          setActiveSection("empty");
          changeSubTitle(null);
          changeServiceTitle(null);
        }
      } else {
        if (specialtiesList && specialtiesList?.length > 0) {
          setActiveSection("specialties");
          changeSubTitle("AddSpecialties");
        } else {
          setActiveSection("empty");
          changeSubTitle(null);
          changeServiceTitle(null);
        }
      }
    }
  };

  const checkSectionToRenderBtnClicked = () => {
    if (btnClicked === "list") {
      if (addedSepacialtyWithServices?.length > 0) {
        setRenderAddedServiceSection(true);
        setRenderEmpatyStateSection(false);
        setRenderServicesSection(false);
        setRenderSpecialtiesSection(false);
        changeSubTitle("AddedServices");
      } else {
        setRenderAddedServiceSection(true);
        setRenderEmpatyStateSection(false);
        setRenderServicesSection(false);
        setRenderSpecialtiesSection(false);
        changeSubTitle(null);
      }
      setIsAddSpecialtiesAndServicesBTNClicked(false);
    } else if (btnClicked === "listSpecialties") {
      getSpecialties();
      dispatch(
        getBranchServicesRequest({
          page: -1,
          branch_id: viewBranchDetails?.id,
        })
      );
      setRenderAddedServiceSection(false);
      setServiceTitle(null);
      changeServiceTitle(null);
      setRenderEmpatyStateSection(false);
      setRenderServicesSection(false);
      setRenderSpecialtiesSection(true);
      changeSubTitle("AddSpecialties");
      setIsAddSpecialtiesAndServicesBTNClicked(true);
    }
  };

  const renderServicesContent = () => {
    if (serviceslist?.length === 0) {
      setNoAssgiendServicesOnSpecialtyAlert(true);
    } else {
      setNoAssgiendServicesOnSpecialtyAlert(false);
    }
    const servicesListMapped = serviceslist?.map((service, i) => {
      return {
        serviceId: service.id,
        relatedSpecialtyId: service.specialty.id,
        name_en: service.title_en,
        name_ar: service.title_ar,
        status: service.status,
        rejection_reason: service.rejection_reason,
        service_type: service.service_type || "single_service",
        sessions_count: service.sessions_count || "",
        expiry_weeks: service.expiry_weeks || "",
        schedule_type: service.schedule_type || null,
        cancellation_window_hours: service.cancellation_window_hours || "",
        // inline validation error keys (mapped to same keys used in AddEditManualServiceModal)
        sessionsCountError: "",
        expiryWeeksError: "",
        cancellationWindowHoursError: "",
        scheduleTypeError: "",
        isChoosen: false,
        details: {
          feesRange: {
            from: "",
            to: "",
            hasErrors: false,
            errors: [],
          },
          currency: null,
          duration: "",
          // description: '',
          descriptionEN: {
            value: "",
            hasErrors: false,
            errors: [],
          },
          descriptionAR: {
            value: "",
            hasErrors: false,
            errors: [],
          },
          hasErrors: false,
          errors: [],
        },
      };
    });
    setMappedServices(servicesListMapped);
    if (viewBranchDetails?.specialties?.length > 0) {
      setNativeServices(viewBranchDetails.specialties);
    }
    if (addedSepacialtyWithServices?.length > 0) {
      const newMappedServices = servicesListMapped.map((service) => {
        const targerSpecialty = addedSepacialtyWithServices.find((elt) => {
          return elt.realSpecialtyId === service.relatedSpecialtyId;
        });
        const ServiceFound = targerSpecialty?.services?.find(
          (x) => x.service_id === service.serviceId
        );
        let serviceCopy = {
          ...service,
          id: service.id,
          service_id: service.service_id,
          isChoosen: false,
          details: {
            feesRange: {
              from: "",
              to: "",
              hasErrors: false,
              errors: [],
            },
            currency: null,
            duration: "",
            // description: '',
            descriptionEN: {
              value: "",
              hasErrors: false,
              errors: [],
            },
            descriptionAR: {
              value: "",
              hasErrors: false,
              errors: [],
            },
            hasErrors: false,
            errors: [],
          },
        };
        if (ServiceFound) {
          serviceCopy.isChoosen = true;
          serviceCopy.id = ServiceFound.id;
          serviceCopy.service_id = service.service_id;
          serviceCopy.service_type = ServiceFound.service_type || "single_service";
          serviceCopy.sessions_count = ServiceFound.sessions_count || "";
          serviceCopy.expiry_weeks = ServiceFound.expiry_weeks || "";
          serviceCopy.schedule_type = ServiceFound.schedule_type || null;
          serviceCopy.cancellation_window_hours = ServiceFound.cancellation_window_hours || "";
          serviceCopy.details = {
            ...ServiceFound.details,
            currency: currencyOptionsList?.find(
              (currency) =>
                currency.id === ServiceFound.currency_id || currency.id === 1
            ),
            duration: ServiceFound.details.duration,
            // description: ServiceFound.details.description,
            descriptionEN: ServiceFound.details.descriptionEN,
            descriptionAR: ServiceFound.details.descriptionAR,
            feesRange: {
              from: ServiceFound.details.feesRange.from,
              to: ServiceFound.details.feesRange.to,
              hasErrors: false,
              errors: [],
            },
          };
        }
        return serviceCopy;
      });
      setFieldValue("choosenServices", newMappedServices);
    } else {
      setFieldValue("choosenServices", [...servicesListMapped]);
    }
  };

  const updateServicesContent = () => {
    setFieldValue("choosenServices", []);
    setMappedServices([]);
    const servicesListMapped = serviceslist?.map((service, i) => {
      return {
        serviceId: service.id,
        name_en: service.title_en,
        name_ar: service.title_ar,
        isChoosen: false,
        details: {
          feesRange: {
            from: "",
            to: "",
            hasErrors: false,
            errors: [],
          },
          currency: null,
          duration: "",
          // description: '',
          descriptionEN: {
            value: "",
            hasErrors: false,
            errors: [],
          },
          descriptionAR: {
            value: "",
            hasErrors: false,
            errors: [],
          },
          hasErrors: false,
          errors: [],
        },
      };
    });
    setFieldValue("choosenServices", servicesListMapped);
    setMappedServices(servicesListMapped);
    if (viewBranchDetails?.specialties?.length > 0) {
      setNativeServices(viewBranchDetails.specialties);
      if (addedSepacialtyWithServices?.length > 0) {
        addedSepacialtyWithServices.forEach((addedSepacialty) => {
          if (addedSepacialty.services.length > 0) {
            addedSepacialty.services.forEach((service) => {
              setFieldValue(
                "choosenServices",
                values["choosenServices"]?.map((choosenService) => {
                  if (choosenService.name_en === service.name_en) {
                    choosenService.isChoosen = true;
                    choosenService.service_id = service.service_id;
                    choosenService.id = service.id;
                    choosenService.details.feesRange.from =
                      service.details.feesRange.from;
                    choosenService.details.feesRange.to =
                      service.details.feesRange.to;
                    choosenService.details.currency = currencyOptionsList?.find(
                      (currency) =>
                        currency.id === service.currency_id || currency.id === 1
                    );
                    choosenService.details.duration = service.details.duration;
                    // choosenService.details.description = service.details.description;
                    choosenService.details.descriptionEN.value =
                      service.details.descriptionEN.value;
                    choosenService.details.descriptionAR.value =
                      service.details.descriptionAR.value;
                  }
                  return choosenService;
                })
              );
            });
          } else {
            dispatch(
              getBranchServicesRequest({
                page: -1,
                branch_id: viewBranchDetails?.id,
              })
            );
          }
        });
      }
    }
  };

  const handleExpandFuntion = (isExpanded, id) => {
    if (isExpanded) {
      dispatch(
        getBranchServicesRequest({
          page: -1,
          branch_id: viewBranchDetails?.id,
        })
      );
    }
  };

  const getSpecialties = () => {
    dispatch(
      getSpecialtiesRequest({
        page: -1,
        service_provider_id: providerid,
      })
    );
  };

  const getServicesBySpecialtyId = (specialtyId) => {
    dispatch(
      getServicesRequest({
        specialty_id: specialtyId,
        service_provider_id: providerid,
      })
    );
  };

  const renderEmptyState = () => {
    return (
      !isLoading && (
        <div className="bg-white rounded-4 services-page d-flex justify-content-center align-items-center flex-column m-4 mt-0">
          <EmptyState
            subTitle={shared.noServicesAddedyet}
            ButtonLabel={branches.addBranch.labels.addSepicialtiesAndServices}
            handleBtnAction={() => {
              dispatch(getBranchResponse({}));
              getSpecialties();
              setNoAssgiendServicesOnSpecialtyAlert(false);
              setIsAddSpecialtiesAndServicesBTNClicked(true);
            }}
          />
        </div>
      )
    );
  };

  const renderSpecialties = () => {
    return (
      !isLoading && (
        <>
          {specialtiesList?.length > 0 ? (
            <div>
              {specialtiesList?.map((specialty, index) => {
                return (
                  <div key={specialty.id}>
                    <div
                      className="d-flex justify-content-between align-items-center pointer"
                      onClick={() => {
                        clearServicesState();
                        setChoosenSpecialtyId(specialty.id);
                        setRenderSpecialtiesSection(false);
                        setRenderServicesSection(true);
                        setActiveSection("services");
                        changeSubTitle("AddSpecialties");
                        changeServiceTitle(
                          lang === "en"
                            ? specialty.title_en
                            : specialty.title_ar
                        );
                        setRenderAddedServiceSection(false);
                      }}
                    >
                      <p className="text-gray fsize-16 mb-0">
                        {renderTextEllipsis(
                          lang === "en"
                            ? specialty.title_en
                            : specialty.title_ar
                        )}
                      </p>
                      {specialty.status === "pending" ||
                      specialty.status === "rejected" ? (
                        <div className="d-flex align-items-center gap-2">
                          <Tooltip
                            title={
                              <span className="fsize-12">
                                {
                                  branches.addBranch.specialtiesAndServices
                                    .addedSpecialtyInfo
                                }
                              </span>
                            }
                            content={
                              <span className="text-bg-primary-mid fsize-14 font-reguler">
                                <InfoOutlined
                                  size={26}
                                  style={{ color: "#D19985" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                  }}
                                />
                              </span>
                            }
                          />
                          <div className="arrow-bg">
                            {lang === "en" ? (
                              <KeyboardArrowRight />
                            ) : (
                              <KeyboardArrowLeft />
                            )}
                          </div>
                        </div>
                      ) : (
                        <div className="arrow-bg">
                          {lang === "en" ? (
                            <KeyboardArrowRight />
                          ) : (
                            <KeyboardArrowLeft />
                          )}
                        </div>
                      )}
                    </div>
                    {/* {index !== specialtiesList?.length - 1 && <div className="line-separator"></div>} */}
                    <div className="line-separator"></div>
                    {index === specialtiesList?.length - 1 && (
                      <div
                        className="d-flex align-items-center text-secondary pointer"
                        onClick={() => {
                          setShowAddEditManualSpecialtyModal(true);
                          setSelectedManualAddedSpecialty(null);
                        }}
                      >
                        <Add />
                        {
                          branches.addBranch.specialtiesAndServices
                            .createNewSpecialty
                        }
                        <Tooltip
                          title={
                            <span className="fsize-12">
                              {
                                branches.addBranch.specialtiesAndServices
                                  .createNewSpecialtyInfo
                              }
                            </span>
                          }
                          content={
                            <span className="text-bg-primary-mid fsize-14 font-reguler">
                              <InfoOutlined
                                size={26}
                                style={{ color: "#D19985" }}
                              />
                            </span>
                          }
                        />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="bg-white rounded-4 services-page d-flex justify-content-center align-items-center flex-column m-4 mt-0">
              <EmptyState
                subTitle={shared.noSpecialtiesOnCategoryyet}
                showActionButton={true}
                ButtonLabel={
                  <span className="d-flex align-items-center gap-2">
                    {
                      branches.addBranch.specialtiesAndServices
                        .createNewSpecialty
                    }
                    <Tooltip
                      title={
                        <span className="fsize-12">
                          {
                            branches.addBranch.specialtiesAndServices
                              .createNewSpecialtyInfo
                          }
                        </span>
                      }
                      content={
                        <span className="text-bg-primary-mid fsize-14 font-reguler">
                          <InfoOutlined size={26} style={{ color: "white" }} />
                        </span>
                      }
                    />
                  </span>
                }
                handleBtnAction={() => {
                  setShowAddEditManualSpecialtyModal(true);
                  setSelectedManualAddedSpecialty(null);
                }}
              />
            </div>
          )}
        </>
      )
    );
  };

  const handleCloseShowLeaveWarningModal = () => {
    setShowLeaveWarningModal(false);
  };

  const handleConfirmShowLeaveWarning = () => {
    changeSubTitle(null);
    changeServiceTitle(null);
    setRenderServicesSection(false);
    setRenderAddedServiceSection(false);
    setShowLeaveWarningModal(false);
    setRenderAddedServiceSection(true);
    setServiceTitle(null);
  };

  const showAddedServicesAfterSave = () => {
    if (requestStatus) {
      setRenderSpecialtiesSection(false);
      changeSubTitle(null);
      changeSubTitle(null);
      setRenderEmpatyStateSection(false);
      setRenderServicesSection(false);
      setRenderAddedServiceSection(true);
      if (branchCreatedId) {
        dispatch(getBranchRequest(branchCreatedId));
      }
      if (parentProps?.location?.state?.branchDataToEdit) {
        dispatch(
          getBranchRequest(parentProps?.location?.state?.branchDataToEdit?.id)
        );
      }
      setFieldValue("choosenServices", []);
      setMappedServices([]);
      setAddedSepacialtyWithServices([]);
      ressetBtnClicked();
      dispatch(getRequestStatus(false));
    }
  };

  const isEditSpecialtySaveBtnDisabled = () => {
    // disable if no service is choosen or choosen sevice without the required data
    const selectedServices = values["choosenServices"]?.filter(
      (item) => item.isChoosen
    );
    const hasSelectedServicesWithoutRequiredData = values[
      "choosenServices"
    ]?.some(
      (item) => {
        if (!item.isChoosen) return false;
        
        // Basic required fields
        const missingBasicFields = !item.details.duration ||
          !item.details.currency ||
          !item.details.feesRange.from;
        
        // For multi_session services, check additional required fields
        if (item.service_type === "multi_session") {
          const sessionsCount = typeof item.sessions_count === "string" 
            ? item.sessions_count.trim() 
            : item.sessions_count;
          const expiryWeeks = typeof item.expiry_weeks === "string" 
            ? item.expiry_weeks.trim() 
            : item.expiry_weeks;
          const cancellationHours = typeof item.cancellation_window_hours === "string" 
            ? item.cancellation_window_hours.trim() 
            : item.cancellation_window_hours;
          
          // Check if fields are missing
          const missingMultiSessionFields = !sessionsCount || sessionsCount === "" ||
            !expiryWeeks || expiryWeeks === "" ||
            !item.schedule_type ||
            !cancellationHours || cancellationHours === "";
          
          // Check if values meet minimum requirements
          const sessionsCountNum = sessionsCount ? parseInt(sessionsCount, 10) : 0;
          const expiryWeeksNum = expiryWeeks ? parseInt(expiryWeeks, 10) : 0;
          const cancellationHoursNum = cancellationHours ? parseInt(cancellationHours, 10) : 0;
          const invalidValues = isNaN(sessionsCountNum) || sessionsCountNum < 2 ||
            isNaN(expiryWeeksNum) || expiryWeeksNum <= 0 ||
            isNaN(cancellationHoursNum) || cancellationHoursNum <= 0;
          
          return missingBasicFields || missingMultiSessionFields || invalidValues;
        }
        
        return missingBasicFields;
      }
    );
    return !selectedServices.length || hasSelectedServicesWithoutRequiredData;
  };

  const isEditServiceSaveBtnDisabled = (specialtyId, serviceId) => {
    // disable if the service missing any required data
    const specialty = addedSepacialtyWithServices?.find(
      (item) => item.id === specialtyId
    );
    const service = specialty?.services?.find((item) => item.id === serviceId);
    
    // Basic required fields
    const missingBasicFields = !service?.details.duration ||
      !service?.details.currency ||
      !service?.details.feesRange.from;
    
    // For multi_session services, check additional required fields
    if (service?.service_type === "multi_session") {
      const sessionsCount = typeof service.sessions_count === "string" 
        ? service.sessions_count.trim() 
        : service.sessions_count;
      const expiryWeeks = typeof service.expiry_weeks === "string" 
        ? service.expiry_weeks.trim() 
        : service.expiry_weeks;
      const cancellationHours = typeof service.cancellation_window_hours === "string" 
        ? service.cancellation_window_hours.trim() 
        : service.cancellation_window_hours;
      
      // Check if fields are missing
      const missingMultiSessionFields = !sessionsCount || sessionsCount === "" ||
        !expiryWeeks || expiryWeeks === "" ||
        !service.schedule_type ||
        !cancellationHours || cancellationHours === "";
      
      // Check if values meet minimum requirements
      const sessionsCountNum = sessionsCount ? parseInt(sessionsCount, 10) : 0;
      const expiryWeeksNum = expiryWeeks ? parseInt(expiryWeeks, 10) : 0;
      const cancellationHoursNum = cancellationHours ? parseInt(cancellationHours, 10) : 0;
      const invalidValues = isNaN(sessionsCountNum) || sessionsCountNum < 2 ||
        isNaN(expiryWeeksNum) || expiryWeeksNum <= 0 ||
        isNaN(cancellationHoursNum) || cancellationHoursNum <= 0;
      
      return missingBasicFields || missingMultiSessionFields || invalidValues;
    }
    
    return missingBasicFields;
  };

  const isEditServiceTotalSaveBtnDisabled = () => {
    const hasServicesWithoutRequiredData = addedSepacialtyWithServices?.some(
      (item) => item.services?.some((service) => service.editMood)
    );
    return hasServicesWithoutRequiredData;
  };

  const renderServices = () => {
    return (
      !isLoading && (
        <>
          {!noAssgiendServicesOnSpecialtyAlert ? (
            <>
              <div>
                {values["choosenServices"]?.map((service, i) => {
                  return (
                    <div key={service.serviceId}>
                      <div className="d-flex align-items-center justify-content-between text-secondary pointer">
                        <Checkbox
                          color="secondary"
                          label={
                            <span className="text-gray fsize-16">
                              {renderTextEllipsis(
                                lang === "en"
                                  ? service.name_en
                                  : service.name_ar
                              )}
                            </span>
                          }
                          labelClass="font-reguler text-dark fsize-16"
                          checked={values["choosenServices"][i].isChoosen}
                          name={
                            lang === "en" ? service.name_en : service.name_ar
                          }
                          id={service.serviceId}
                          onChange={(elementIsChecked, e) => {
                            // update service variable
                            setFieldValue(
                              "choosenServices",
                              values["choosenServices"].map((service) => {
                                if (service.serviceId == e.target.id) {
                                  service.isChoosen = elementIsChecked;
                                }
                                return service;
                              })
                            );
                            setMappedServices(
                              mappedServices?.map((service) => {
                                if (service.serviceId == e.target.id) {
                                  service.isChoosen = elementIsChecked;
                                }
                                return service;
                              })
                            );
                          }}
                        />
                        {(service.status === "pending" ||
                          service.status === "rejected") && (
                          <div className="d-flex align-items-center gap-2">
                            <Tooltip
                              title={
                                <span className="fsize-12">
                                  {service.status === "pending"
                                    ? branches.addBranch.specialtiesAndServices
                                        .addedServiceInfo
                                    : service.rejection_reason}
                                </span>
                              }
                              content={
                                <span className="text-bg-primary-mid fsize-14 font-reguler mx-2">
                                  {service.status === "pending" ? (
                                    <InfoOutlined
                                      size={26}
                                      style={{
                                        color: "#D19985",
                                        cursor: "default",
                                      }}
                                    />
                                  ) : (
                                    <PriorityHighIcon size={26} />
                                  )}
                                </span>
                              }
                            />
                          </div>
                        )}
                      </div>
                      {/* render details */}
                      {service.isChoosen && (
                        <div className="ms-4 ps-2 service-details-section">
                          <div className="mb-3">
                            <div className="d-flex align-items-center gap-2">
                              <Input
                                id="feesRangeFrom"
                                label={branches.addBranch.specialtiesAndServices.feesRange}
                                name="feesRangeFrom"
                                type="text"
                                placeholder={
                                  branches.addBranch.specialtiesAndServices.feesRange
                                }
                                value={
                                  values["choosenServices"][i]?.details
                                    .feesRange.from
                                }
                                inputWrapperClass="select-bg-white"
                                labelClassName="text-dark font-medium mb-2"
                                onChange={(value) => {
                                  if (ONE_NUMBERS_ONLY.test(value) || !value) {
                                    setFieldValue(values["choosenServices"], [
                                      ...values["choosenServices"],
                                      values["choosenServices"].map(
                                        (mappedService) => {
                                          if (
                                            mappedService.serviceId ===
                                            service.serviceId
                                          ) {
                                            if (
                                              mappedService.details.feesRange.errors.includes(
                                                "onlyNumbersAreAllowed"
                                              ) ||
                                              mappedService.details.feesRange.errors.includes(
                                                "fromIsRequired"
                                              )
                                            ) {
                                              mappedService.details.feesRange.hasErrors = false;
                                              mappedService.details.feesRange.errors =
                                                mappedService.details.feesRange.errors.filter(
                                                  (error) =>
                                                    error !==
                                                      "onlyNumbersAreAllowed" &&
                                                    error !== "fromIsRequired"
                                                );
                                            }
                                            if (
                                              POSITIVE_TWO_DICIMAL_ONLY.test(
                                                value
                                              )
                                            ) {
                                              mappedService.details.feesRange.from =
                                                value;
                                              // For multi_session, set fees_to to same as fees_from
                                              if (mappedService.service_type === "multi_session") {
                                                mappedService.details.feesRange.to = value;
                                              }
                                            }
                                          }
                                          return service;
                                        }
                                      ),
                                    ]);
                                  } else {
                                    setFieldValue(values["choosenServices"], [
                                      ...values["choosenServices"],
                                      values["choosenServices"].map(
                                        (mappedService) => {
                                          if (
                                            mappedService.serviceId ===
                                            service.serviceId
                                          ) {
                                            if (
                                              !mappedService.details.feesRange.errors.includes(
                                                "onlyNumbersAreAllowed"
                                              )
                                            ) {
                                              mappedService.details.feesRange.hasErrors = true;
                                              mappedService.details.feesRange.errors.push(
                                                "onlyNumbersAreAllowed"
                                              );
                                            }
                                          }
                                          return service;
                                        }
                                      ),
                                    ]);
                                  }
                                }}
                                required
                              />
                            </div>
                            {values["choosenServices"][i]?.details.feesRange
                              .hasErrors && (
                              <span>
                                {values["choosenServices"][
                                  i
                                ]?.details.feesRange.errors.map((err) => {
                                  return (
                                    <div className="text-red fweight-600">
                                      {lang == "en" ? (
                                        errorss.find((x) => {
                                          return x.errorTitle == err;
                                        })?.errorMessaged
                                      ) : (
                                        <>
                                          {
                                            errorss.find((x) => {
                                              return x.errorTitle == err;
                                            })?.errorMessaged
                                          }
                                        </>
                                      )}
                                    </div>
                                  );
                                })}
                              </span>
                            )}
                          </div>
                          <div className="mb-3">
                            <div className="d-flex align-items-center">
                              <Select
                                wrapperClass="label-inline"
                                name="currency"
                                labelClassName="text-dark font-medium mb-2"
                                label={
                                  branches.addBranch.specialtiesAndServices
                                    .currency
                                }
                                options={currencyOptionsList}
                                // inputClassName="input-wrapper select-bg-white"
                                inputClassName={`input-wrapper mb-3 select-bg-white ${
                                  lang === "ar" ? "handle-padding" : ""
                                }`}
                                placeholder={
                                  branches.addBranch.specialtiesAndServices
                                    .currency
                                }
                                value={
                                  values["choosenServices"][i]?.details.currency
                                }
                                onChange={(value) => {
                                  setFieldValue(values["choosenServices"], [
                                    ...values["choosenServices"],
                                    values["choosenServices"].map(
                                      (mappedService) => {
                                        if (
                                          mappedService.serviceId ===
                                          service.serviceId
                                        ) {
                                          if (
                                            mappedService.details.errors.includes(
                                              "currencyIsRequired"
                                            )
                                          ) {
                                            if (
                                              mappedService.details.errors
                                                .length === 0
                                            ) {
                                              mappedService.details.hasErrors = false;
                                            }
                                            mappedService.details.errors =
                                              mappedService.details.errors.filter(
                                                (error) =>
                                                  error !== "currencyIsRequired"
                                              );
                                          }
                                          mappedService.details.currency =
                                            value;
                                        }
                                        return service;
                                      }
                                    ),
                                  ]);
                                }}
                                required
                              />
                            </div>
                            {values["choosenServices"][i]?.details.hasErrors &&
                              values["choosenServices"][
                                i
                              ]?.details.errors.includes(
                                "currencyIsRequired"
                              ) && (
                                <span>
                                  {values["choosenServices"][
                                    i
                                  ]?.details.errors.map((err) => {
                                    return (
                                      <div className="text-red fweight-600">
                                        {lang == "en" ? (
                                          errorss.find((x) => {
                                            return (
                                              x.errorTitle == err &&
                                              err == "currencyIsRequired"
                                            );
                                          })?.errorMessaged
                                        ) : (
                                          <>
                                            {
                                              errorss.find((x) => {
                                                return (
                                                  x.errorTitle == err &&
                                                  err == "currencyIsRequired"
                                                );
                                              })?.errorMessaged
                                            }
                                          </>
                                        )}
                                      </div>
                                    );
                                  })}
                                </span>
                              )}
                          </div>
                          <div className="mb-3">
                            <div className="d-flex align-items-center">
                              <Input
                                id="duration"
                                label={
                                  branches.addBranch.specialtiesAndServices
                                    .duration
                                }
                                name="duration"
                                type="text"
                                placeholder={
                                  branches.addBranch.specialtiesAndServices
                                    .duration
                                }
                                value={
                                  values["choosenServices"][i]?.details.duration
                                }
                                inputWrapperClass="select-bg-white"
                                labelClassName="text-dark font-medium mb-2"
                                onChange={(value) => {
                                  if (
                                    (ONE_NUMBERS_ONLY.test(value) ||
                                      value === "") &&
                                    value !== "0"
                                  ) {
                                    setFieldValue(values["choosenServices"], [
                                      ...values["choosenServices"],
                                      values["choosenServices"].map(
                                        (mappedService) => {
                                          if (
                                            mappedService.serviceId ===
                                            service.serviceId
                                          ) {
                                            if (
                                              mappedService.details.errors.includes(
                                                "onlyNumbersAreAllowed"
                                              ) ||
                                              mappedService.details.errors.includes(
                                                "durationIsRequired"
                                              ) ||
                                              mappedService.details.errors.includes(
                                                "durationCanNotBeLessThanOne"
                                              )
                                            ) {
                                              if (
                                                mappedService.details.errors
                                                  .length === 0
                                              ) {
                                                mappedService.details.hasErrors = false;
                                              }
                                              mappedService.details.errors =
                                                mappedService.details.errors.filter(
                                                  (error) =>
                                                    error !==
                                                      "onlyNumbersAreAllowed" &&
                                                    error !==
                                                      "durationIsRequired" &&
                                                    error !==
                                                      "durationCanNotBeLessThanOne"
                                                );
                                            }
                                            mappedService.details.duration =
                                              value;
                                          }
                                          return service;
                                        }
                                      ),
                                    ]);
                                  } else {
                                    setFieldValue(values["choosenServices"], [
                                      ...values["choosenServices"],
                                      values["choosenServices"].map(
                                        (mappedService) => {
                                          if (
                                            mappedService.serviceId ===
                                            service.serviceId
                                          ) {
                                            if (
                                              value === "0" &&
                                              !mappedService.details.errors.includes(
                                                "durationCanNotBeLessThanOne"
                                              )
                                            ) {
                                              mappedService.details.hasErrors = true;
                                              mappedService.details.errors = [
                                                "durationCanNotBeLessThanOne",
                                              ];
                                            } else if (
                                              !mappedService.details.errors.includes(
                                                "onlyNumbersAreAllowed"
                                              )
                                            ) {
                                              mappedService.details.hasErrors = true;
                                              // mappedService.details.errors.push('onlyNumbersAreAllowed');
                                              mappedService.details.errors = [
                                                "onlyNumbersAreAllowed",
                                              ];
                                            }
                                          }
                                          return service;
                                        }
                                      ),
                                    ]);
                                  }
                                }}
                                required
                              />
                              <p className="text-gray fsize-16 mx-2 mb-2">
                                {
                                  branches.addBranch.specialtiesAndServices
                                    .minutes
                                }
                              </p>
                            </div>
                            {values["choosenServices"][i]?.details
                              .hasErrors && (
                              <span>
                                {values["choosenServices"][
                                  i
                                ]?.details.errors.map((err) => {
                                  return (
                                    <div className="text-red fweight-600">
                                      {lang == "en" ? (
                                        errorss.find((x) => {
                                          return (
                                            x.errorTitle == err &&
                                            err !== "currencyIsRequired"
                                          );
                                        })?.errorMessaged
                                      ) : (
                                        <>
                                          {
                                            errorss.find((x) => {
                                              return (
                                                x.errorTitle == err &&
                                                err !== "currencyIsRequired"
                                              );
                                            })?.errorMessaged
                                          }
                                        </>
                                      )}
                                    </div>
                                  );
                                })}
                              </span>
                            )}
                          </div>
                          {/* <Input
                            id="description"
                            label={branches.addBranch.specialtiesAndServices.description}
                            name="description"
                            type="text"
                            placeholder={branches.addBranch.specialtiesAndServices.description}
                            value={values['choosenServices'][i]?.details.description}
                            inputWrapperClass="mb-3 select-bg-white"
                            labelClassName="text-dark font-medium mb-2"
                            onChange={(value) => {
                              setFieldValue(values['choosenServices'], [
                                ...values['choosenServices'],
                                values['choosenServices'].map((mappedService) => {
                                  if (mappedService.serviceId === service.serviceId) {
                                    mappedService.details.description = value;
                                  }
                                  return service;
                                }),
                              ]);
                            }}
                          /> */}
                          <div className="mb-3">
                            <Input
                              id="descriptionEN"
                              label={
                                branches.addBranch.specialtiesAndServices
                                  .descriptionEN
                              }
                              name="descriptionEN"
                              type="text"
                              multiline
                              inputProps={{ maxLength: 125 }}
                              placeholder={
                                branches.addBranch.specialtiesAndServices
                                  .descriptionEN
                              }
                              value={
                                values["choosenServices"][i]?.details
                                  .descriptionEN.value
                              }
                              labelClassName="text-dark font-medium mb-2"
                              inputClass="select-bg-white p-14"
                              onChange={(value) => {
                                if (
                                  ONLY_ENGLISH_SPACE_DOT_COMMA_SEMICOLON.test(
                                    value
                                  ) ||
                                  !value
                                ) {
                                  setFieldValue(values["choosenServices"], [
                                    ...values["choosenServices"],
                                    values["choosenServices"].map(
                                      (mappedService) => {
                                        if (
                                          mappedService.serviceId ===
                                          service.serviceId
                                        ) {
                                          mappedService.details.descriptionEN.hasErrors = false;
                                          mappedService.details.descriptionEN.errors =
                                            "";
                                          mappedService.details.descriptionEN.value =
                                            value;
                                        }
                                        return service;
                                      }
                                    ),
                                  ]);
                                } else {
                                  setFieldValue(values["choosenServices"], [
                                    ...values["choosenServices"],
                                    values["choosenServices"].map(
                                      (mappedService) => {
                                        if (
                                          mappedService.serviceId ===
                                          service.serviceId
                                        ) {
                                          mappedService.details.descriptionEN.hasErrors = true;
                                          mappedService.details.descriptionEN.errors =
                                            "onlyEnglishSpaceDotCommaSemicolon";
                                        }
                                        return service;
                                      }
                                    ),
                                  ]);
                                }
                              }}
                            />
                            {service?.details.descriptionEN.hasErrors && (
                              <div className="text-red fweight-600">
                                {
                                  errorss.find((x) => {
                                    return (
                                      x.errorTitle ==
                                      "onlyEnglishSpaceDotCommaSemicolon"
                                    );
                                  })?.errorMessaged
                                }
                              </div>
                            )}
                          </div>
                          <div className="mb-3">
                            <Input
                              id="descriptionAR"
                              label={
                                branches.addBranch.specialtiesAndServices
                                  .descriptionAR
                              }
                              name="descriptionAR"
                              type="text"
                              multiline
                              inputProps={{ maxLength: 125 }}
                              placeholder={
                                branches.addBranch.specialtiesAndServices
                                  .descriptionAR
                              }
                              value={
                                values["choosenServices"][i]?.details
                                  .descriptionAR.value
                              }
                              inputClass="select-bg-white p-14"
                              labelClassName="text-dark font-medium mb-2"
                              onChange={(value) => {
                                if (
                                  ONLY_ARABIC_SPACE_DOT_COMMA_SEMICOLON.test(
                                    value
                                  ) ||
                                  !value
                                ) {
                                  setFieldValue(values["choosenServices"], [
                                    ...values["choosenServices"],
                                    values["choosenServices"].map(
                                      (mappedService) => {
                                        if (
                                          mappedService.serviceId ===
                                          service.serviceId
                                        ) {
                                          mappedService.details.descriptionAR.hasErrors = false;
                                          mappedService.details.descriptionAR.errors =
                                            "";
                                          mappedService.details.descriptionAR.value =
                                            value;
                                        }
                                        return service;
                                      }
                                    ),
                                  ]);
                                } else {
                                  setFieldValue(values["choosenServices"], [
                                    ...values["choosenServices"],
                                    values["choosenServices"].map(
                                      (mappedService) => {
                                        if (
                                          mappedService.serviceId ===
                                          service.serviceId
                                        ) {
                                          mappedService.details.descriptionAR.hasErrors = true;
                                          mappedService.details.descriptionAR.errors =
                                            "onlyArabicSpaceDotCommaSemicolon";
                                        }
                                        return service;
                                      }
                                    ),
                                  ]);
                                }
                              }}
                            />
                            {service?.details.descriptionAR.hasErrors && (
                              <div className="text-red fweight-600">
                                {
                                  errorss.find((x) => {
                                    return (
                                      x.errorTitle ==
                                      "onlyArabicSpaceDotCommaSemicolon"
                                    );
                                  })?.errorMessaged
                                }
                              </div>
                            )}
                          </div>
                          {allowMultiSessions && (service?.service_type === "multi_session" || 
                            (service?.sessions_count || service?.expiry_weeks || service?.schedule_type || service?.cancellation_window_hours)) && (
                            <>
                              <div className="mb-3">
                                <div className="d-flex align-items-center">
                                  <Input
                                    id="sessionsCount"
                                    label={
                                      branches.addBranch
                                        .specialtiesAndServices
                                        .sessionsNumber
                                    }
                                    name="sessionsCount"
                                    type="text"
                                    inputWrapperClass="select-bg-white"
                                    labelClassName="text-dark font-medium mb-2"
                                    required
                                    placeholder={
                                      branches.addBranch
                                        .specialtiesAndServices
                                        .sessionsNumberPlaceholder
                                    }
                                    value={service.sessions_count || ""}
                                    onChange={(value) => {
                                      if (NUMBERS_REGEX.test(value) || !value) {
                                        setFieldValue(values["choosenServices"], [
                                          ...values["choosenServices"],
                                          values["choosenServices"].map(
                                            (mappedService) => {
                                              if (
                                                mappedService.serviceId ===
                                                service.serviceId
                                              ) {
                                                mappedService.sessions_count = value;
                                                // validation: required & min 2 (same as AddEditManualServiceModal)
                                                const trimmed = (value || "").trim();
                                                if (!trimmed) {
                                                  mappedService.sessionsCountError = "required";
                                                } else {
                                                  const numValue = parseInt(trimmed, 10);
                                                  if (Number.isNaN(numValue) || numValue < 2) {
                                                    mappedService.sessionsCountError = "minimumTwoSessionsRequired";
                                                  } else {
                                                    mappedService.sessionsCountError = "";
                                                  }
                                                }
                                              }
                                              return mappedService;
                                            }
                                          ),
                                        ]);
                                      }
                                    }}
                                  />
                                </div>
                                {service.sessionsCountError && (
                                  <div className="text-red fweight-600 mt-1">
                                    {service.sessionsCountError === "minimumTwoSessionsRequired"
                                      ? inputsValidations.minimumTwoSessionsRequired
                                      : inputsValidations.required}
                                  </div>
                                )}
                              </div>
                              <div className="mb-3">
                              <div className="d-flex align-items-center">
                                <Input
                                  id="expiryWeeks"
                                  label={
                                    branches.addBranch
                                      .specialtiesAndServices
                                      .sessionsExpiry
                                  }
                                  name="expiryWeeks"
                                  type="text"
                                  required
                                  placeholder={
                                    branches.addBranch
                                      .specialtiesAndServices
                                      .sessionsExpiryPlaceholder
                                  }
                                  value={service.expiry_weeks || ""}
                                  inputWrapperClass="select-bg-white"
                                  labelClassName="text-dark font-medium mb-2"
                                  onChange={(value) => {
                                    if (NUMBERS_REGEX.test(value) || !value) {
                                      setFieldValue(values["choosenServices"], [
                                        ...values["choosenServices"],
                                        values["choosenServices"].map(
                                          (mappedService) => {
                                            if (
                                              mappedService.serviceId ===
                                              service.serviceId
                                            ) {
                                              mappedService.expiry_weeks = value;
                                              // validation: positive int required (> 0)
                                              const trimmed = (value || "").trim();
                                              if (!trimmed) {
                                                mappedService.expiryWeeksError = "required";
                                              } else {
                                                const numValue = parseInt(trimmed, 10);
                                                if (Number.isNaN(numValue) || numValue <= 0) {
                                                  mappedService.expiryWeeksError = "required";
                                                } else {
                                                  mappedService.expiryWeeksError = "";
                                                }
                                              }
                                            }
                                            return mappedService;
                                          }
                                        ),
                                      ]);
                                    }
                                  }}
                                />
                                 <p className="text-gray fsize-16 mx-2 mb-2">
                                {
                                  branches.addBranch.specialtiesAndServices
                                    .weeks
                                }
                              </p>
                                </div>
                                {service.expiryWeeksError && (
                                  <div className="text-red fweight-600 mt-1">
                                    {inputsValidations.required}
                                  </div>
                                )}
                                </div>
                              <div className="mb-3 d-flex align-items-baseline gap-2">
                                  <div className="text-dark font-medium">
                                    {
                                      branches.addBranch
                                        .specialtiesAndServices
                                        .scheduleType
                                    }
                                    <span className="err-asterisk"> * </span>
                                  </div>
                                  {service.schedule_type && (
                                    <div className="ms-2">
                                      <Tooltip
                                        title={
                                          <span className="fsize-12">
                                            {service.schedule_type === "upfront"
                                              ? branches.addBranch
                                                  .specialtiesAndServices
                                                  .scheduleAllUpfrontTooltip
                                              : service.schedule_type === "rolling"
                                              ? branches.addBranch
                                                  .specialtiesAndServices
                                                  .rollingWindowTooltip
                                              : ""}
                                          </span>
                                        }
                                        content={
                                          <span className="text-bg-primary-mid fsize-14 font-reguler">
                                            <InfoOutlined
                                              size={20}
                                              style={{
                                                color: "#D19985",
                                                cursor: "default",
                                                transform: "translateY(-1px)",
                                              }}
                                            />
                                          </span>
                                        }
                                      />
                                    </div>
                                  )}
                                <div className="d-flex flex-column"> 
                                <Select
                                  name="scheduleType"
                                  labelClassName="d-none"
                                  options={[
                                    {
                                      id: "upfront",
                                      label:
                                      branches.addBranch
                                        .specialtiesAndServices
                                        .scheduleAllUpfront,
                                      value: "upfront",
                                    },
                                    {
                                      id: "rolling",
                                      label:
                                      branches.addBranch
                                        .specialtiesAndServices
                                        .rollingWindow,
                                      value: "rolling",
                                    },
                                  ]}
                                  inputClassName="input-wrapper select-bg-white w-100"
                                  placeholder={
                                    branches.addBranch
                                      .specialtiesAndServices
                                      .scheduleTypePlaceholder
                                  }
                                  value={
                                    service.schedule_type
                                      ? {
                                          id: service.schedule_type,
                                          label:
                                            service.schedule_type === "upfront"
                                              ? branches.addBranch
                                                  .specialtiesAndServices
                                                  .scheduleAllUpfront
                                              : branches.addBranch
                                                  .specialtiesAndServices
                                                  .rollingWindow,
                                          value: service.schedule_type,
                                        }
                                      : null
                                  }
                                  onChange={(value) => {
                                    setFieldValue(values["choosenServices"], [
                                      ...values["choosenServices"],
                                      values["choosenServices"].map(
                                        (mappedService) => {
                                          if (
                                            mappedService.serviceId ===
                                            service.serviceId
                                          ) {
                                            mappedService.schedule_type =
                                              value?.value || null;
                                            // validation: required
                                            if (!value?.value) {
                                              mappedService.scheduleTypeError = "required";
                                            } else {
                                              mappedService.scheduleTypeError = "";
                                            }
                                          }
                                          return mappedService;
                                        }
                                      ),
                                    ]);
                                  }}
                                  required
                                />
                                {service.scheduleTypeError && (
                                  <div className="text-red fweight-600 mt-1">
                                    {inputsValidations.required}
                                  </div>
                                )}
                              </div>
                              </div>
                              <div className="mb-3">
                                <div className="d-flex align-items-center gap-2">
                                  <div className="d-flex align-items-center">
                                    <div className="text-dark font-medium">
                                      {
                                        branches.addBranch
                                          .specialtiesAndServices
                                          .cancellationWindow
                                      }
                                      <span className="err-asterisk"> * </span>
                                    </div>
                                    <div className="ms-2">
                                      <Tooltip
                                        title={
                                          <span className="fsize-12">
                                            {
                                              branches.addBranch
                                                .specialtiesAndServices
                                                .cancellationWindowTooltip
                                            }
                                          </span>
                                        }
                                        content={
                                          <span className="text-bg-primary-mid fsize-14 font-reguler">
                                            <InfoOutlined
                                              size={20}
                                              style={{
                                                color: "#D19985",
                                                cursor: "default",
                                                transform: "translateY(-1px)",
                                              }}
                                            />
                                          </span>
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="d-flex align-items-center">
                                  <Input
                                    id="cancellationWindowHours"
                                    name="cancellationWindowHours"
                                    type="text"
                                    required
                                    placeholder={
                                      branches.addBranch
                                        .specialtiesAndServices
                                        .cancellationWindowPlaceholder
                                    }
                                    value={service.cancellation_window_hours || ""}
                                    inputWrapperClass="mb-0"
                                    labelClassName="d-none"
                                    onChange={(value) => {
                                      if (NUMBERS_REGEX.test(value) || !value) {
                                        setFieldValue(values["choosenServices"], [
                                          ...values["choosenServices"],
                                          values["choosenServices"].map(
                                            (mappedService) => {
                                              if (
                                                mappedService.serviceId ===
                                                service.serviceId
                                              ) {
                                                mappedService.cancellation_window_hours = value;
                                                // validation: positive int required (> 0)
                                                const trimmed = (value || "").trim();
                                                if (!trimmed) {
                                                  mappedService.cancellationWindowHoursError = "required";
                                                } else {
                                                  const numValue = parseInt(trimmed, 10);
                                                  if (Number.isNaN(numValue) || numValue <= 0) {
                                                    mappedService.cancellationWindowHoursError = "required";
                                                  } else {
                                                    mappedService.cancellationWindowHoursError = "";
                                                  }
                                                }
                                              }
                                              return mappedService;
                                            }
                                          ),
                                        ]);
                                      }
                                    }}
                                    />
                                    <p className="text-gray fsize-16 mx-2 mb-2">
                                  {
                                    branches.addBranch.specialtiesAndServices
                                      .hours
                                  }
                                </p>
                                </div>
                                </div>
                                {service.cancellationWindowHoursError && (
                                  <div className="text-red fweight-600 mt-1">
                                    {inputsValidations.required}
                                  </div>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                      )}
                      {/* line */}
                      {<div className="line-separator"></div>}
                    </div>
                  );
                })}
                <div
                  className="d-flex align-items-center text-secondary pointer"
                  onClick={() => {
                    setShowAddEditManualServiceModal(true);
                    setSelectedManualAddedService(null);
                  }}
                >
                  <Add />
                  {allowMultiSessions
                    ? branches.addBranch.specialtiesAndServices
                        .createNewServiceSessions
                    : branches.addBranch.specialtiesAndServices
                        .createNewService}
                  <Tooltip
                    title={
                      <span className="fsize-12">
                        {
                          branches.addBranch.specialtiesAndServices
                            .createNewServiceInfo
                        }
                      </span>
                    }
                    content={
                      <span className="text-bg-primary-mid fsize-14 font-reguler mx-2">
                        <InfoOutlined
                          size={26}
                          style={{ color: "#D19985", cursor: "default" }}
                        />
                      </span>
                    }
                  />
                </div>
              </div>
              <div className="mt-4 py-4 d-flex justify-content-end gap-2">
                <Button
                  onClick={() => {
                    // go back to specialties section
                    checkIfThereIsDataBeforeLeave();
                  }}
                  outlined
                  color={"info"}
                  type="button"
                  label={shared.cancel}
                  labelClass="fsize-16 py-1"
                />
                <Button
                  onClick={() => {
                    let valid = true;
                    // check manual validation
                    values["choosenServices"].map((service) => {
                      if (service.isChoosen) {
                        if (!service.details.feesRange.from) {
                          valid = false;
                          service.details.feesRange.hasErrors = true;
                          if (
                            !service.details.feesRange.errors.includes(
                              "fromIsRequired"
                            )
                          ) {
                            service.details.feesRange.errors.push(
                              "fromIsRequired"
                            );
                          }
                        }
                        if (service.details.currency == null) {
                          valid = false;
                          service.details.hasErrors = true;
                          if (
                            !service.details.errors.includes(
                              "currencyIsRequired"
                            )
                          ) {
                            service.details.errors.push("currencyIsRequired");
                          }
                        }
                        if (service.details.currency == null) {
                          valid = false;
                          service.details.hasErrors = true;
                          if (
                            !service.details.errors.includes(
                              "currencyIsRequired"
                            )
                          ) {
                            service.details.errors.push("currencyIsRequired");
                          }
                        }
                        if (!service.details.duration) {
                          valid = false;
                          service.details.hasErrors = true;
                          if (
                            !service.details.errors.includes(
                              "durationIsRequired"
                            )
                          ) {
                            service.details.errors.push("durationIsRequired");
                          }
                        }
                        // Validate multi-session fields if service type is multi_session
                        if (service.service_type === "multi_session") {
                          const sessionsCount = typeof service.sessions_count === "string" 
                            ? service.sessions_count.trim() 
                            : service.sessions_count;
                          const expiryWeeks = typeof service.expiry_weeks === "string" 
                            ? service.expiry_weeks.trim() 
                            : service.expiry_weeks;
                          const cancellationHours = typeof service.cancellation_window_hours === "string" 
                            ? service.cancellation_window_hours.trim() 
                            : service.cancellation_window_hours;
                          
                          if (!sessionsCount || sessionsCount === "") {
                            valid = false;
                          } else {
                            const sessionsCountNum = parseInt(sessionsCount, 10);
                            if (isNaN(sessionsCountNum) || sessionsCountNum < 2) {
                              valid = false;
                            }
                          }
                          if (!expiryWeeks || expiryWeeks === "") {
                            valid = false;
                          } else {
                            const expiryWeeksNum = parseInt(expiryWeeks, 10);
                            if (isNaN(expiryWeeksNum) || expiryWeeksNum <= 0) {
                              valid = false;
                            }
                          }
                          if (!service.schedule_type) {
                            valid = false;
                          }
                          if (!cancellationHours || cancellationHours === "") {
                            valid = false;
                          } else {
                            const cancellationHoursNum = parseInt(cancellationHours, 10);
                            if (isNaN(cancellationHoursNum) || cancellationHoursNum <= 0) {
                              valid = false;
                            }
                          }
                        }
                      }
                      return service;
                    });
                    // add all checked service with details to branch services Call API
                    if (valid) {
                      let arr = [];
                      values["choosenServices"].forEach((service) => {
                        if (service.isChoosen) {
                          let obj = {};
                          obj.id = service.id; // if service is already added to branch
                          obj.service_id = service.serviceId;
                          obj.fees_from = service.details.feesRange.from;
                          // For multi_session, set fees_to to same as fees_from
                          const serviceType = service.service_type || "single_service";
                          obj.fees_to = serviceType === "multi_session" 
                            ? service.details.feesRange.from 
                            : service.details.feesRange.to;
                          obj.duration_mins = service.details.duration;
                          obj.currency_id = service.details.currency?.id;
                          // lang === 'en'
                          //   ? (obj.description_en = service.details.description)
                          //   : (obj.description_ar = service.details.description);
                          obj.description_en =
                            service.details.descriptionEN.value.trim();
                          obj.description_ar =
                            service.details.descriptionAR.value.trim();
                          obj.title_en = service.name_en;
                          obj.title_ar = service.name_ar;
                          // Include multi-session fields if service_type is multi_session
                          obj.service_type = serviceType;
                          
                          if (serviceType === "multi_session") {
                            // Convert to numbers, ensuring they're valid
                            const sessionsCount = service.sessions_count
                              ? (typeof service.sessions_count === "string" 
                                  ? parseInt(service.sessions_count, 10)
                                  : service.sessions_count)
                              : null;
                            const expiryWeeks = service.expiry_weeks
                              ? (typeof service.expiry_weeks === "string"
                                  ? parseInt(service.expiry_weeks, 10)
                                  : service.expiry_weeks)
                              : null;
                            const scheduleType = service.schedule_type || null;
                            const cancellationHours = service.cancellation_window_hours
                              ? (typeof service.cancellation_window_hours === "string"
                                  ? parseInt(service.cancellation_window_hours, 10)
                                  : service.cancellation_window_hours)
                              : null;
                            
                            // Always include fields for multi_session services
                            // Backend will validate, but we ensure proper types
                            obj.sessions_count = (sessionsCount !== null && !isNaN(sessionsCount)) ? sessionsCount : 0;
                            obj.expiry_weeks = (expiryWeeks !== null && !isNaN(expiryWeeks)) ? expiryWeeks : 0;
                            obj.schedule_type = scheduleType || "";
                            obj.cancellation_window_hours = (cancellationHours !== null && !isNaN(cancellationHours)) ? cancellationHours : 0;
                          }
                          arr.push(obj);
                        } else {
                          let obj = {};
                          obj.id = service.id; // if service is already added to branch
                          obj.service_id = service.serviceId;
                          obj.fees_from = service.details.feesRange.from;
                          // Include service_type even when destroying
                          const serviceType = service.service_type || "single_service";
                          // For multi_session, set fees_to to same as fees_from
                          obj.fees_to = serviceType === "multi_session" 
                            ? service.details.feesRange.from 
                            : service.details.feesRange.to;
                          obj.duration_mins = service.details.duration;
                          obj.currency_id = service.details.currency?.id;
                          // lang === 'en'
                          //   ? (obj.description_en = service.details.description)
                          //   : (obj.description_ar = service.details.description);
                          obj.description_en =
                            service.details.descriptionEN.value.trim();
                          obj.description_ar =
                            service.details.descriptionAR.value.trim();
                          obj.title_en = service.name_en;
                          obj.title_ar = service.name_ar;
                          obj._destroy = true;
                          obj.service_type = serviceType;
                          
                          if (serviceType === "multi_session") {
                            // Convert to numbers, ensuring they're valid
                            const sessionsCount = service.sessions_count
                              ? (typeof service.sessions_count === "string"
                                  ? parseInt(service.sessions_count, 10)
                                  : service.sessions_count)
                              : null;
                            const expiryWeeks = service.expiry_weeks
                              ? (typeof service.expiry_weeks === "string"
                                  ? parseInt(service.expiry_weeks, 10)
                                  : service.expiry_weeks)
                              : null;
                            const scheduleType = service.schedule_type || null;
                            const cancellationHours = service.cancellation_window_hours
                              ? (typeof service.cancellation_window_hours === "string"
                                  ? parseInt(service.cancellation_window_hours, 10)
                                  : service.cancellation_window_hours)
                              : null;
                            
                            // Include values even when destroying (for proper cleanup)
                            obj.sessions_count = (sessionsCount !== null && !isNaN(sessionsCount)) ? sessionsCount : 0;
                            obj.expiry_weeks = (expiryWeeks !== null && !isNaN(expiryWeeks)) ? expiryWeeks : 0;
                            obj.schedule_type = scheduleType || "";
                            obj.cancellation_window_hours = (cancellationHours !== null && !isNaN(cancellationHours)) ? cancellationHours : 0;
                          }
                          arr.push(obj);
                        }
                      });
                      dispatch(
                        editBranchRequest({
                          id:
                            branchCreatedId ||
                            parentProps?.location?.state?.branchDataToEdit?.id,
                          data: {
                            branch_services_attributes: arr,
                          },
                        })
                      );
                      setServiceTitle(null);
                    }
                  }}
                  type="submit"
                  label={shared.save}
                  labelClass="fsize-16 text-white py-1"
                  disabled={isEditSpecialtySaveBtnDisabled()}
                />
              </div>
              <Modal
                open={showLeaveWarningModal}
                handleClose={handleCloseShowLeaveWarningModal}
                title={branches.addBranch.labels.confirmCancel}
                contentClass="mb-5 pb-2 text-primary"
                content={
                  <span>{branches.addBranch.labels.confirmCancelMessage}</span>
                }
                confirmBtnTxt={shared.confirm}
                maxWidth="xs"
                cancelBtnTxt={shared.cancel}
                isContentText={false}
                handleConfirm={handleConfirmShowLeaveWarning}
                handleCancel={handleCloseShowLeaveWarningModal}
                modalClass="delete-services-modal"
                actionsClass="container px-4"
                confirmBtnClass="btn-secondary fsize-14 text-white py-2 "
                cancelBtnClass="fsize-14 py-2"
              />
            </>
          ) : (
            <div className="bg-white rounded-4 services-page d-flex justify-content-center align-items-center flex-column m-4 mt-0">
              <EmptyState
                subTitle={shared.noServicesAddedyet}
                // ButtonLabel={shared.back}
                // handleBtnAction={() => {
                //   setRenderSpecialtiesSection(true);
                //   changeSubTitle('AddSpecialties');
                //   setRenderServicesSection(false);
                //   setRenderAddedServiceSection(false);
                // }}
                showActionButton={false}
                otherActionContent={() => (
                  <div className="d-flex justify-content-center align-items-center gap-2">
                    <Button
                      label={shared.back}
                      type="button"
                      labelClass="fsize-16 text-white px-5"
                      onClick={() => {
                        setRenderSpecialtiesSection(true);
                        changeSubTitle("AddSpecialties");
                        setRenderServicesSection(false);
                        setRenderAddedServiceSection(false);
                      }}
                    />
                    <Button
                      label={
                        <span className="d-flex align-items-center gap-2">
                          {allowMultiSessions
                            ? branches.addBranch.specialtiesAndServices
                                .createNewServiceSessions
                            : branches.addBranch.specialtiesAndServices
                                .createNewService}
                          <Tooltip
                            title={
                              <span className="fsize-12">
                                {
                                  branches.addBranch.specialtiesAndServices
                                    .createNewServiceInfo
                                }
                              </span>
                            }
                            content={
                              <span className="text-bg-primary-mid fsize-14 font-reguler">
                                <InfoOutlined
                                  size={26}
                                  style={{ color: "white" }}
                                />
                              </span>
                            }
                          />
                        </span>
                      }
                      type="button"
                      labelClass="fsize-16 text-white px-5"
                      onClick={() => {
                        setShowAddEditManualServiceModal(true);
                        setSelectedManualAddedService(null);
                      }}
                    />
                  </div>
                )}
              />
            </div>
          )}
        </>
      )
    );
  };

  const checkIfThereIsDataBeforeLeave = () => {
    if (values["choosenServices"]?.length > 0) {
      let ShowAlert = false;
      values["choosenServices"].forEach((service) => {
        if (service.isChoosen) {
          ShowAlert = true;
        }
      });
      if (ShowAlert) {
        setShowLeaveWarningModal(true);
      } else {
        clearServicesState();
        setRenderSpecialtiesSection(true);
        changeSubTitle("AddSpecialties");
        changeServiceTitle(null);
        setRenderServicesSection(false);
        setRenderAddedServiceSection(false);
      }
    }
  };

  const handleDeleteClick = (id) => {
    setdeleteSpecialtyId(id);
    setOpenDeleteSepecialtyConfirm(true);
  };

  const handleDeleteSpecialty = () => {
    dispatch(
      deleteBranchSpecialtyRequest({
        id: deleteSpecialtyId,
      })
    );
    dispatch(getDeleteBranchSpecialityStatusRequest(null));
    setTimeout(() => {
      dispatch(
        getBranchRequest(
          branchid ||
            parentProps?.location?.state?.branchDataToEdit?.id ||
            branchCreatedId
        )
      );
    }, 1000);
    setOpenDeleteSepecialtyConfirm(false);
    // Check if there is only one specialty in the branch
    if (branchServicesList?.length === 1) {
      setRenderEmpatyStateSection(false);
      setRenderSpecialtiesSection(false);
      changeSubTitle(null);
      setRenderServicesSection(false);
      setRenderAddedServiceSection(true);
    } else {
      dispatch(getBranchRequest(branchCreatedId));
      setRenderAddedServiceSection(false);
      setTimeout(() => {
        setRenderAddedServiceSection(true);
      }, 500);
    }
    setdeleteSpecialtyId(null);
  };

  const handleCloseDeleteSpecilatyConfirmModal = () => {
    setOpenDeleteSepecialtyConfirm(false);
  };

  const handleDeleteServiceClick = (service) => {
    setdeleteServiceId(service.id);
    setOpenDeleteServiceConfirm(true);
  };

  const handleDeleteService = () => {
    dispatch(
      deleteBranchServiceRequest({
        id: deleteServiceId,
      })
    );
    dispatch(getDeleteBranchServiceStatusRequest(null));
    resetForm();
    updateServicesContent();
    setdeleteServiceId(null);
    setOpenDeleteServiceConfirm(false);
    setRenderEmpatyStateSection(true);
    setRenderAddedServiceSection(false);
    setTimeout(() => {
      setRenderEmpatyStateSection(false);
      setRenderAddedServiceSection(true);
    }, 200);
  };

  const handleCloseDeleteServiceConfirmModal = () => {
    setOpenDeleteServiceConfirm(false);
  };

  const viewAddedServices = () => {
    return (
      <>
        {addedSepacialtyWithServices?.length > 0 ? (
          <>
            <div>
              {addedSepacialtyWithServices?.map((specialty, index) => {
                return (
                  <div key={specialty.id}>
                    <Accordion
                      wrapperClassName={`services-section ${
                        index !== 0 && "mt-4"
                      }`}
                      label={
                        <div className="d-flex justify-content-between align-items-center w-100">
                          <div className="fsize-16 fweight-600 text-primary text-break">
                            {renderTextEllipsis(
                              lang === "en"
                                ? specialty?.title_en || specialty?.specialtyName
                                : specialty?.title_ar || specialty?.specialtyName
                            )}
                          </div>
                          <div>
                            {specialty.status === "pending" ||
                              (specialty.status === "rejected" && (
                                <div className="d-flex align-items-center gap-2">
                                  <Tooltip
                                    title={
                                      <span className="fsize-12">
                                        {specialty.status === "pending"
                                          ? branches.addBranch
                                              .specialtiesAndServices
                                              .addedSpecialtyInfo
                                          : specialty.rejection_reason}
                                      </span>
                                    }
                                    content={
                                      <span className="text-bg-primary-mid fsize-14 font-reguler">
                                        <InfoOutlined
                                          size={26}
                                          style={{
                                            color: "#D19985",
                                            cursor: "default",
                                          }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                          }}
                                        />
                                      </span>
                                    }
                                  />
                                </div>
                              ))}
                            <div className="d-flex gap-2 align-items-center">
                              <div
                                className="small-icon-bg"
                                onClick={() => {
                                  // delete specialty with all services
                                  handleDeleteClick(specialty.id);
                                }}
                              >
                                <DeleteBgIcon />
                              </div>
                              <div
                                className="small-icon-bg"
                                onClick={() => {
                                  // clearServicesState();
                                  setChoosenSpecialtyId(
                                    specialty.realSpecialtyId
                                  );
                                  setRenderSpecialtiesSection(false);
                                  setTimeout(() => {
                                    setRenderServicesSection(true);
                                  }, 1000);
                                  changeSubTitle("AddSpecialties");
                                  changeServiceTitle(
                                    lang === "en"
                                      ? specialty.title_en
                                      : specialty.title_ar
                                  );
                                  setRenderAddedServiceSection(false);
                                  setServiceTitle(specialty);
                                }}
                              >
                                <EditBgIcon />
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      labelClassName={"text-primary flex-grow-1"}
                      body={
                        <>
                          {specialty?.services?.map((service, i) => {
                            return (
                              <div key={service.id}>
                                <div
                                  key={service.id}
                                  className={`${i !== 0 && "mt-4"} mb-2 px-4`}
                                >
                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <p className="mb-0 text-primary fsize-16">
                                      {renderTextEllipsis(
                                        lang === "en"
                                          ? service.name_en
                                          : service.name_ar
                                      )}
                                    </p>
                                    <div className="d-flex h-fit-content">
                                      <div>
                                        <Switch
                                          checked={handleToggleButtonValue(
                                            service.service_id
                                          )}
                                          name="published"
                                          onChange={(e) => {
                                            if (e.target.checked) {
                                              handleActivateOrDeactivateService(
                                                service
                                              );
                                            } else {
                                              setDeactivatedService(service);
                                              setShowDeactivateServicePopup(
                                                true
                                              );
                                            }
                                          }}
                                          disabled={
                                            viewBranchDetails.status ===
                                              "deactivated" ||
                                            viewBranchDetails.status ===
                                              "unpublished"
                                              ? true
                                              : false
                                          }
                                        />
                                      </div>

                                      <div
                                        className="small-icon-bg pointer"
                                        onClick={() => {
                                          handleDeleteServiceClick(service);
                                        }}
                                      >
                                        <DeleteBgIcon />
                                      </div>
                                      <div
                                        className="small-icon-bg pointer"
                                        onClick={() => {
                                          setAddedSepacialtyWithServices(
                                            addedSepacialtyWithServices.map(
                                              (specialty) => {
                                                specialty.services?.map(
                                                  (mappedService) => {
                                                    if (
                                                      mappedService.id ===
                                                      service?.id
                                                    ) {
                                                      service.editMood = true;
                                                    }
                                                    return mappedService;
                                                  }
                                                );
                                                return specialty;
                                              }
                                            )
                                          );
                                        }}
                                      >
                                        <EditBgIcon />
                                      </div>
                                    </div>
                                  </div>
                                  {/* details only */}
                                  {service.editMood === false && (
                                    <div>
                                      <div className="d-flex text-gray align-items-center gap-2 text-gray fsize-16">
                                        <CreditCardOutlined className="text-gray" />
                                        <div className="text-gray fsize-16 mb-0">
                                          {
                                            branches.addBranch
                                              .specialtiesAndServices.feesRange
                                          }
                                          :
                                        </div>
                                        <div>
                                          {service.service_type !== "multi_session" && service.details.feesRange.to && (
                                            <span>
                                              {
                                                branches.addBranch
                                                  .specialtiesAndServices.from
                                              }
                                            </span>
                                          )}
                                          <span className="mx-1">
                                            {service.details.feesRange.from ??
                                              " ... "}
                                          </span>
                                          {lang === "en" ? (
                                            currencyOptionsList.find(
                                              (currency) =>
                                                currency.id ===
                                                service?.details?.currency?.id
                                            )?.label
                                          ) : (
                                            <>
                                              {
                                                currencyOptionsList.find(
                                                  (currency) =>
                                                    currency.id ===
                                                    service?.details?.currency
                                                      ?.id
                                                )?.label
                                              }
                                            </>
                                          )}
                                        </div>
                                        {service.service_type !== "multi_session" && service.details.feesRange.to && (
                                          <>
                                            <div>
                                              <span>-</span>
                                            </div>
                                            <div>
                                              {
                                                branches.addBranch
                                                  .specialtiesAndServices.to
                                              }
                                              <span className="mx-1">
                                                {service.details.feesRange.to ??
                                                  " ... "}
                                              </span>
                                              {lang === "en" ? (
                                                currencyOptionsList.find(
                                                  (currency) =>
                                                    currency.id ===
                                                    service?.details?.currency
                                                      ?.id
                                                )?.label
                                              ) : (
                                                <>
                                                  {
                                                    currencyOptionsList.find(
                                                      (currency) =>
                                                        currency.id ===
                                                        service?.details
                                                          ?.currency?.id
                                                    )?.label
                                                  }
                                                </>
                                              )}
                                            </div>
                                          </>
                                        )}
                                      </div>
                                      <div className="d-flex my-1 gap-2 align-items-center">
                                        <AccessTimeOutlined className="text-gray" />
                                        <div className="text-gray fsize-16 mb-0 d-flex gap-2">
                                          <span>
                                            {
                                              branches.addBranch
                                                .specialtiesAndServices.duration
                                            }
                                            :
                                          </span>
                                          <span>
                                            {service.details.duration}
                                          </span>
                                          <span>
                                            {" "}
                                            {
                                              branches.addBranch
                                                .specialtiesAndServices.minutes
                                            }
                                          </span>
                                        </div>
                                      </div>
                                      <div className="d-flex gap-2 align-items-start">
                                        <ReceiptLongOutlined className="text-gray" />
                                        <div className="text-gray fsize-16 mb-0 d-flex gap-2">
                                          <span>
                                            {
                                              branches.addBranch
                                                .specialtiesAndServices
                                                .description
                                            }
                                            :
                                          </span>
                                          {/* <span>{service.details.description ? service.details.description : '-'}</span> */}
                                          <span>
                                            {lang === "en"
                                              ? renderTextEllipsis(service.details.descriptionEN.value) || "-"
                                              : renderTextEllipsis(service.details.descriptionAR.value) || "-"}
                                          </span>
                                        </div>
                                      </div>
                                      <div className="d-flex gap-2 align-items-center">
                                        <CategoryOutlined className="text-gray" />
                                        <div className="text-gray fsize-16 mb-0 d-flex gap-2">
                                          <span>
                                            {
                                              branches.addBranch
                                                .specialtiesAndServices
                                                .serviceType
                                            }
                                            :
                                          </span>
                                          <span>
                                            {service.service_type === "multi_session"
                                              ? branches.addBranch
                                                  .specialtiesAndServices
                                                  .multiSessions
                                              : branches.addBranch
                                                  .specialtiesAndServices
                                                  .singleService}
                                          </span>
                                        </div>
                                      </div>
                                      {service.service_type === "multi_session" && (
                                        <>
                                          <div className="d-flex gap-2 align-items-center">
                                            <EventNoteOutlined className="text-gray" />
                                            <div className="text-gray fsize-16 mb-0 d-flex gap-2">
                                              <span>
                                                {
                                                  branches.addBranch
                                                    .specialtiesAndServices
                                                    .sessionsNumber
                                                }
                                                :
                                              </span>
                                              <span>
                                                {service.sessions_count || "-"}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="d-flex gap-2 align-items-center">
                                            <ScheduleOutlined className="text-gray" />
                                            <div className="text-gray fsize-16 mb-0 d-flex gap-2">
                                              <span>
                                                {
                                                  branches.addBranch
                                                    .specialtiesAndServices
                                                    .sessionsExpiry
                                                }
                                                :
                                              </span>
                                              <span>
                                                {service.expiry_weeks || "-"}{" "}
                                                {service.expiry_weeks &&
                                                  branches.addBranch
                                                    .specialtiesAndServices.weeks}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="d-flex gap-2 align-items-center">
                                            <CalendarViewWeekOutlined className="text-gray" />
                                            <div className="text-gray fsize-16 mb-0 d-flex gap-2">
                                              <span>
                                                {
                                                  branches.addBranch
                                                    .specialtiesAndServices
                                                    .scheduleType
                                                }
                                                :
                                              </span>
                                              <span>
                                                {service.schedule_type ===
                                                "upfront"
                                                  ? branches.addBranch
                                                      .specialtiesAndServices
                                                      .scheduleAllUpfront
                                                  : service.schedule_type ===
                                                    "rolling"
                                                  ? branches.addBranch
                                                      .specialtiesAndServices
                                                      .rollingWindow
                                                  : "-"}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="d-flex gap-2 align-items-center">
                                            <CancelOutlined className="text-gray" />
                                            <div className="text-gray fsize-16 mb-0 d-flex gap-2">
                                              <span>
                                                {
                                                  branches.addBranch
                                                    .specialtiesAndServices
                                                    .cancellationWindow
                                                }
                                                :
                                              </span>
                                              <span>
                                                {service.cancellation_window_hours ||
                                                  "-"}{" "}
                                                {service.cancellation_window_hours &&
                                                  branches.addBranch
                                                    .specialtiesAndServices.hours}
                                              </span>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  )}
                                  {/* edit input */}
                                  {service.editMood === true && (
                                    <>
                                      <div className="service-details-section flex-grow-1">
                                        <div className=" mb-2">
                                          <div className="d-flex align-items-center gap-2">
                                            <Input
                                              id="feesRangeFrom"
                                              label={
                                                branches.addBranch.specialtiesAndServices.feesRange
                                              }
                                              name="feesRangeFrom"
                                              type="text"
                                              required
                                              placeholder={
                                                branches.addBranch.specialtiesAndServices.feesRange
                                              }
                                              value={
                                                service.details.feesRange.from
                                              }
                                              inputWrapperClass="select-bg-white"
                                              labelClassName="text-dark font-medium mb-2"
                                              onChange={(value) => {
                                                if (
                                                  ONE_NUMBERS_ONLY.test(
                                                    value
                                                  ) ||
                                                  !value
                                                ) {
                                                  setAddedSepacialtyWithServices(
                                                    addedSepacialtyWithServices.map(
                                                      (specialty) => {
                                                        specialty.services?.map(
                                                          (mappedService) => {
                                                            if (
                                                              mappedService.id ===
                                                              service?.id
                                                            ) {
                                                              if (
                                                                mappedService.details.feesRange.errors.includes(
                                                                  "onlyNumbersAreAllowed"
                                                                ) ||
                                                                mappedService.details.errors.includes(
                                                                  "fromIsRequired"
                                                                )
                                                              ) {
                                                                mappedService.details.feesRange.hasErrors = false;
                                                                mappedService.details.feesRange.errors =
                                                                  mappedService.details.feesRange.errors.filter(
                                                                    (error) =>
                                                                      error !==
                                                                        "onlyNumbersAreAllowed" ||
                                                                      error !==
                                                                        "fromIsRequired"
                                                                  );
                                                              }
                                                              if (
                                                                POSITIVE_TWO_DICIMAL_ONLY.test(
                                                                  value
                                                                )
                                                              ) {
                                                                mappedService.details.feesRange.from =
                                                                  value;
                                                                // For multi_session, set fees_to to same as fees_from
                                                                if (mappedService.service_type === "multi_session") {
                                                                  mappedService.details.feesRange.to = value;
                                                                }
                                                              }
                                                            }
                                                            return mappedService;
                                                          }
                                                        );
                                                        return specialty;
                                                      }
                                                    )
                                                  );
                                                } else {
                                                  setAddedSepacialtyWithServices(
                                                    addedSepacialtyWithServices.map(
                                                      (specialty) => {
                                                        specialty.services?.map(
                                                          (mappedService) => {
                                                            if (
                                                              mappedService.id ===
                                                              service?.id
                                                            ) {
                                                              if (
                                                                !mappedService.details.feesRange.errors.includes(
                                                                  "onlyNumbersAreAllowed"
                                                                )
                                                              ) {
                                                                mappedService.details.feesRange.hasErrors = true;
                                                                mappedService.details.feesRange.errors.push(
                                                                  "onlyNumbersAreAllowed"
                                                                );
                                                              }
                                                            }
                                                            return mappedService;
                                                          }
                                                        );
                                                        return specialty;
                                                      }
                                                    )
                                                  );
                                                }
                                              }}
                                            />
                                          </div>
                                          {service?.details.feesRange
                                            .hasErrors && (
                                            <span>
                                              {service?.details.feesRange.errors.map(
                                                (err) => {
                                                  return (
                                                    <div className="text-red fweight-600">
                                                      {lang == "en" ? (
                                                        errorss.find((x) => {
                                                          return (
                                                            x.errorTitle == err
                                                          );
                                                        })?.errorMessaged
                                                      ) : (
                                                        <>
                                                          {
                                                            errorss.find(
                                                              (x) => {
                                                                return (
                                                                  x.errorTitle ==
                                                                  err
                                                                );
                                                              }
                                                            )?.errorMessaged
                                                          }
                                                        </>
                                                      )}
                                                    </div>
                                                  );
                                                }
                                              )}
                                            </span>
                                          )}
                                        </div>
                                        <div className="d-flex align-items-center">
                                          <Select
                                            wrapperClass="label-inline"
                                            name="currency"
                                            required
                                            labelClassName="text-dark font-medium mb-2"
                                            label={
                                              branches.addBranch
                                                .specialtiesAndServices.currency
                                            }
                                            options={currencyOptionsList}
                                            inputClassName={`input-wrapper mb-3 select-bg-white ${
                                              lang === "ar"
                                                ? "handle-padding"
                                                : ""
                                            }`}
                                            placeholder={
                                              branches.addBranch
                                                .specialtiesAndServices.currency
                                            }
                                            value={currencyOptionsList?.find(
                                              (x) =>
                                                x.id ===
                                                service?.details?.currency?.id
                                            )}
                                            onChange={(value) => {
                                              setAddedSepacialtyWithServices(
                                                addedSepacialtyWithServices.map(
                                                  (specialty) => {
                                                    specialty.services?.map(
                                                      (mappedService) => {
                                                        if (
                                                          mappedService.id ===
                                                          service?.id
                                                        ) {
                                                          mappedService.details.currency =
                                                            value;
                                                        }
                                                        return mappedService;
                                                      }
                                                    );
                                                    return specialty;
                                                  }
                                                )
                                              );
                                            }}
                                          />
                                        </div>
                                        <div className="mb-3">
                                          <div className="d-flex align-items-center">
                                            <Input
                                              id="duration"
                                              label={
                                                branches.addBranch
                                                  .specialtiesAndServices
                                                  .duration
                                              }
                                              name="duration"
                                              type="text"
                                              required
                                              placeholder={
                                                branches.addBranch
                                                  .specialtiesAndServices
                                                  .duration
                                              }
                                              value={service.details.duration}
                                              inputWrapperClass="select-bg-white"
                                              labelClassName="text-dark font-medium mb-2"
                                              onChange={(value) => {
                                                if (
                                                  (ONE_NUMBERS_ONLY.test(
                                                    value
                                                  ) ||
                                                    value === "") &&
                                                  value !== "0"
                                                ) {
                                                  setAddedSepacialtyWithServices(
                                                    addedSepacialtyWithServices.map(
                                                      (specialty) => {
                                                        specialty.services?.map(
                                                          (mappedService) => {
                                                            if (
                                                              mappedService.id ===
                                                              service?.id
                                                            ) {
                                                              if (
                                                                mappedService.details.errors.includes(
                                                                  "onlyNumbersAreAllowed"
                                                                ) ||
                                                                mappedService.details.errors.includes(
                                                                  "durationIsRequired"
                                                                ) ||
                                                                mappedService.details.errors.includes(
                                                                  "durationCanNotBeLessThanOne"
                                                                )
                                                              ) {
                                                                mappedService.details.hasErrors = false;
                                                                mappedService.details.errors =
                                                                  mappedService.details.errors.filter(
                                                                    (error) =>
                                                                      error !==
                                                                        "onlyNumbersAreAllowed" ||
                                                                      error !==
                                                                        "durationIsRequired" ||
                                                                      error !==
                                                                        "durationCanNotBeLessThanOne"
                                                                  );
                                                              }
                                                              mappedService.details.duration =
                                                                value;
                                                            }
                                                            return mappedService;
                                                          }
                                                        );
                                                        return specialty;
                                                      }
                                                    )
                                                  );
                                                } else {
                                                  setAddedSepacialtyWithServices(
                                                    addedSepacialtyWithServices.map(
                                                      (specialty) => {
                                                        specialty.services?.map(
                                                          (mappedService) => {
                                                            if (
                                                              mappedService.id ===
                                                              service?.id
                                                            ) {
                                                              if (
                                                                value === "0" &&
                                                                !mappedService.details.errors.includes(
                                                                  "durationCanNotBeLessThanOne"
                                                                )
                                                              ) {
                                                                mappedService.details.hasErrors = true;
                                                                mappedService.details.errors =
                                                                  [
                                                                    "durationCanNotBeLessThanOne",
                                                                  ];
                                                              } else if (
                                                                !mappedService.details.errors.includes(
                                                                  "onlyNumbersAreAllowed"
                                                                )
                                                              ) {
                                                                mappedService.details.hasErrors = true;
                                                                mappedService.details.errors =
                                                                  [
                                                                    "onlyNumbersAreAllowed",
                                                                  ];
                                                              }
                                                            }
                                                            return mappedService;
                                                          }
                                                        );
                                                        return specialty;
                                                      }
                                                    )
                                                  );
                                                }
                                              }}
                                            />
                                            <p className="text-gray fsize-16 mx-2 mb-0">
                                              {
                                                branches.addBranch
                                                  .specialtiesAndServices
                                                  .minutes
                                              }
                                            </p>
                                          </div>
                                          {service?.details.hasErrors && (
                                            <span>
                                              {service?.details.errors.map(
                                                (err) => {
                                                  return (
                                                    <div className="text-red fweight-600">
                                                      {lang == "en" ? (
                                                        errorss.find((x) => {
                                                          return (
                                                            x.errorTitle == err
                                                          );
                                                        })?.errorMessaged
                                                      ) : (
                                                        <>
                                                          {
                                                            errorss.find(
                                                              (x) => {
                                                                return (
                                                                  x.errorTitle ==
                                                                  err
                                                                );
                                                              }
                                                            )?.errorMessaged
                                                          }
                                                        </>
                                                      )}
                                                    </div>
                                                  );
                                                }
                                              )}
                                            </span>
                                          )}
                                        </div>
                                        {/* <Input
                                          id="description"
                                          label={branches.addBranch.specialtiesAndServices.description}
                                          name="description"
                                          type="text"
                                          placeholder={branches.addBranch.specialtiesAndServices.description}
                                          value={service.details.description}
                                          inputWrapperClass="mb-3 select-bg-white"
                                          labelClassName="text-dark font-medium mb-2"
                                          onChange={(value) => {
                                            setAddedSepacialtyWithServices(
                                              addedSepacialtyWithServices.map((specialty) => {
                                                specialty.services?.map((mappedService) => {
                                                  if (mappedService.id === service?.id) {
                                                    mappedService.details.description = value;
                                                  }
                                                  return mappedService;
                                                });
                                                return specialty;
                                              })
                                            );
                                          }}
                                        /> */}
                                        <div className="mb-3">
                                          <Input
                                            id="descriptionEN"
                                            label={
                                              branches.addBranch
                                                .specialtiesAndServices
                                                .descriptionEN
                                            }
                                            name="descriptionEN"
                                            type="text"
                                            multiline
                                            inputProps={{ maxLength: 125 }}
                                            placeholder={
                                              branches.addBranch
                                                .specialtiesAndServices
                                                .descriptionEN
                                            }
                                            value={
                                              service.details.descriptionEN
                                                .value
                                            }
                                            inputClass="bg-white p-14"
                                            labelClassName="text-dark font-medium mb-2"
                                            onChange={(value) => {
                                              if (
                                                ONLY_ENGLISH_SPACE_DOT_COMMA_SEMICOLON.test(
                                                  value
                                                ) ||
                                                !value
                                              ) {
                                                setAddedSepacialtyWithServices(
                                                  addedSepacialtyWithServices.map(
                                                    (specialty) => {
                                                      specialty.services?.map(
                                                        (mappedService) => {
                                                          if (
                                                            mappedService.id ===
                                                            service?.id
                                                          ) {
                                                            mappedService.details.descriptionEN.hasErrors = false;
                                                            mappedService.details.descriptionEN.errors =
                                                              "";
                                                            mappedService.details.descriptionEN.value =
                                                              value;
                                                          }
                                                          return mappedService;
                                                        }
                                                      );
                                                      return specialty;
                                                    }
                                                  )
                                                );
                                              } else {
                                                setAddedSepacialtyWithServices(
                                                  addedSepacialtyWithServices.map(
                                                    (specialty) => {
                                                      specialty.services?.map(
                                                        (mappedService) => {
                                                          if (
                                                            mappedService.id ===
                                                            service?.id
                                                          ) {
                                                            mappedService.details.descriptionEN.hasErrors = true;
                                                            mappedService.details.descriptionEN.errors =
                                                              "onlyEnglishSpaceDotCommaSemicolon";
                                                          }
                                                          return mappedService;
                                                        }
                                                      );
                                                      return specialty;
                                                    }
                                                  )
                                                );
                                              }
                                            }}
                                          />
                                          {service?.details.descriptionEN
                                            .hasErrors && (
                                            <div className="text-red fweight-600">
                                              {
                                                errorss.find((x) => {
                                                  return (
                                                    x.errorTitle ==
                                                    "onlyEnglishSpaceDotCommaSemicolon"
                                                  );
                                                })?.errorMessaged
                                              }
                                            </div>
                                          )}
                                        </div>
                                        <div className="mb-3">
                                          <Input
                                            id="descriptionAR"
                                            label={
                                              branches.addBranch
                                                .specialtiesAndServices
                                                .descriptionAR
                                            }
                                            name="descriptionAR"
                                            type="text"
                                            multiline
                                            inputProps={{ maxLength: 125 }}
                                            placeholder={
                                              branches.addBranch
                                                .specialtiesAndServices
                                                .descriptionAR
                                            }
                                            value={
                                              service.details.descriptionAR
                                                .value
                                            }
                                            labelClassName="text-dark font-medium mb-2"
                                            inputClass="bg-white p-14"
                                            onChange={(value) => {
                                              if (
                                                ONLY_ARABIC_SPACE_DOT_COMMA_SEMICOLON.test(
                                                  value
                                                ) ||
                                                !value
                                              ) {
                                                setAddedSepacialtyWithServices(
                                                  addedSepacialtyWithServices.map(
                                                    (specialty) => {
                                                      specialty.services?.map(
                                                        (mappedService) => {
                                                          if (
                                                            mappedService.id ===
                                                            service.id
                                                          ) {
                                                            mappedService.details.descriptionAR.hasErrors = false;
                                                            mappedService.details.descriptionAR.errors =
                                                              "";
                                                            mappedService.details.descriptionAR.value =
                                                              value;
                                                          }
                                                          return mappedService;
                                                        }
                                                      );
                                                      return specialty;
                                                    }
                                                  )
                                                );
                                              } else {
                                                setAddedSepacialtyWithServices(
                                                  addedSepacialtyWithServices.map(
                                                    (specialty) => {
                                                      specialty.services?.map(
                                                        (mappedService) => {
                                                          if (
                                                            mappedService.id ===
                                                            service.id
                                                          ) {
                                                            mappedService.details.descriptionAR.hasErrors = true;
                                                            mappedService.details.descriptionAR.errors =
                                                              "onlyArabicSpaceDotCommaSemicolon";
                                                          }
                                                          return mappedService;
                                                        }
                                                      );
                                                      return specialty;
                                                    }
                                                  )
                                                );
                                              }
                                            }}
                                          />

                                          {service?.details.descriptionAR
                                            .hasErrors && (
                                            <div className="text-red fweight-600">
                                              {
                                                errorss.find((x) => {
                                                  return (
                                                    x.errorTitle ==
                                                    "onlyArabicSpaceDotCommaSemicolon"
                                                  );
                                                })?.errorMessaged
                                              }
                                            </div>
                                          )}
                                        </div>
                                        {(service?.service_type === "multi_session" || 
                                          (service?.sessions_count || service?.expiry_weeks || service?.schedule_type || service?.cancellation_window_hours)) && (
                                          <>
                                            <div className="mb-3">
                                              <div className="d-flex align-items-center">
                                                <Input
                                                  id="sessionsCount"
                                                  label={
                                                    branches.addBranch
                                                      .specialtiesAndServices
                                                      .sessionsNumber
                                                  }
                                                  name="sessionsCount"
                                                  type="text"
                                                  required
                                                  placeholder={
                                                    branches.addBranch
                                                      .specialtiesAndServices
                                                      .sessionsNumberPlaceholder
                                                  }
                                                  value={service.sessions_count || ""}
                                                  inputWrapperClass="select-bg-white"
                                                  labelClassName="text-dark font-medium mb-2"
                                                  onChange={(value) => {
                                                    if (
                                                      NUMBERS_REGEX.test(value) ||
                                                      !value
                                                    ) {
                                                      setAddedSepacialtyWithServices(
                                                        addedSepacialtyWithServices.map(
                                                          (specialty) => {
                                                            specialty.services?.map(
                                                              (mappedService) => {
                                                                if (
                                                                  mappedService.id ===
                                                                  service?.id
                                                                ) {
                                                                  mappedService.sessions_count =
                                                                    value;
                                                                // validation: required & min 2 (same as AddEditManualServiceModal)
                                                                const trimmed = (value || "").trim();
                                                                if (!trimmed) {
                                                                  mappedService.sessionsCountError = "required";
                                                                } else {
                                                                  const numValue = parseInt(trimmed, 10);
                                                                  if (Number.isNaN(numValue) || numValue < 2) {
                                                                    mappedService.sessionsCountError = "minimumTwoSessionsRequired";
                                                                  } else {
                                                                    mappedService.sessionsCountError = "";
                                                                  }
                                                                }
                                                                }
                                                                return mappedService;
                                                              }
                                                            );
                                                            return specialty;
                                                          }
                                                        )
                                                      );
                                                    }
                                                  }}
                                                />
                                              </div>
                                              {service.sessionsCountError && (
                                                <div className="text-red fweight-600 mt-1">
                                                  {service.sessionsCountError === "minimumTwoSessionsRequired"
                                                    ? inputsValidations.minimumTwoSessionsRequired
                                                    : inputsValidations.required}
                                                </div>
                                              )}
                                            </div>
                                            <div className="mb-3">
                                              <div className="d-flex align-items-center">
                                                <Input
                                                  id="expiryWeeks"
                                                  label={
                                                    branches.addBranch
                                                      .specialtiesAndServices
                                                      .sessionsExpiry
                                                  }
                                                  name="expiryWeeks"
                                                  type="text"
                                                  required
                                                  placeholder={
                                                    branches.addBranch
                                                      .specialtiesAndServices
                                                      .sessionsExpiryPlaceholder
                                                  }
                                                  value={service.expiry_weeks || ""}
                                                  inputWrapperClass="select-bg-white"
                                                  labelClassName="text-dark font-medium mb-2"
                                                  onChange={(value) => {
                                                    if (
                                                      NUMBERS_REGEX.test(value) ||
                                                      !value
                                                    ) {
                                                      setAddedSepacialtyWithServices(
                                                        addedSepacialtyWithServices.map(
                                                          (specialty) => {
                                                            specialty.services?.map(
                                                              (mappedService) => {
                                                                if (
                                                                  mappedService.id ===
                                                                  service?.id
                                                                ) {
                                                                  mappedService.expiry_weeks =
                                                                    value;
                                                                // validation: positive int required (> 0)
                                                                const trimmed = (value || "").trim();
                                                                if (!trimmed) {
                                                                  mappedService.expiryWeeksError = "required";
                                                                } else {
                                                                  const numValue = parseInt(trimmed, 10);
                                                                  if (Number.isNaN(numValue) || numValue <= 0) {
                                                                    mappedService.expiryWeeksError = "required";
                                                                  } else {
                                                                    mappedService.expiryWeeksError = "";
                                                                  }
                                                                }
                                                                }
                                                                return mappedService;
                                                              }
                                                            );
                                                            return specialty;
                                                          }
                                                        )
                                                      );
                                                    }
                                                  }}
                                                />
                                                <p className="text-gray fsize-16 mx-2 mb-2">
                                                  {
                                                    branches.addBranch.specialtiesAndServices
                                                      .weeks
                                                  }
                                                </p>
                                              </div>
                                              {service.expiryWeeksError && (
                                                <div className="text-red fweight-600 mt-1">
                                                  {inputsValidations.required}
                                                </div>
                                              )}
                                            </div>
                                            <div className="mb-3 d-flex align-items-baseline gap-2">
                                              <div className="text-dark font-medium">
                                                {
                                                  branches.addBranch
                                                    .specialtiesAndServices
                                                    .scheduleType
                                                }
                                                <span className="err-asterisk"> * </span>
                                              </div>
                                              {service.schedule_type && (
                                                <div className="ms-2">
                                                  <Tooltip
                                                    title={
                                                      <span className="fsize-12">
                                                        {service.schedule_type === "upfront"
                                                          ? branches.addBranch
                                                              .specialtiesAndServices
                                                              .scheduleAllUpfrontTooltip
                                                          : service.schedule_type === "rolling"
                                                          ? branches.addBranch
                                                              .specialtiesAndServices
                                                              .rollingWindowTooltip
                                                          : ""}
                                                      </span>
                                                    }
                                                    content={
                                                      <span className="text-bg-primary-mid fsize-14 font-reguler">
                                                        <InfoOutlined
                                                          size={20}
                                                          style={{
                                                            color: "#D19985",
                                                            cursor: "default",
                                                            transform: "translateY(-1px)",
                                                          }}
                                                        />
                                                      </span>
                                                    }
                                                  />
                                                </div>
                                              )}
                                              <div className="d-flex flex-column">
                                                <Select
                                                  name="scheduleType"
                                                  labelClassName="d-none"
                                                  options={[
                                                    {
                                                      id: "upfront",
                                                      label:
                                                        branches.addBranch
                                                          .specialtiesAndServices
                                                          .scheduleAllUpfront,
                                                      value: "upfront",
                                                    },
                                                    {
                                                      id: "rolling",
                                                      label:
                                                        branches.addBranch
                                                          .specialtiesAndServices
                                                          .rollingWindow,
                                                      value: "rolling",
                                                    },
                                                  ]}
                                                  inputClassName="input-wrapper select-bg-white w-100"
                                                  placeholder={
                                                    branches.addBranch
                                                      .specialtiesAndServices
                                                      .scheduleTypePlaceholder
                                                  }
                                                  value={
                                                    service.schedule_type
                                                      ? {
                                                          id: service.schedule_type,
                                                          label:
                                                            service.schedule_type === "upfront"
                                                              ? branches.addBranch
                                                                  .specialtiesAndServices
                                                                  .scheduleAllUpfront
                                                              : branches.addBranch
                                                                  .specialtiesAndServices
                                                                  .rollingWindow,
                                                          value: service.schedule_type,
                                                        }
                                                      : null
                                                  }
                                                  onChange={(value) => {
                                                    setAddedSepacialtyWithServices(
                                                      addedSepacialtyWithServices.map(
                                                        (specialty) => {
                                                          specialty.services?.map(
                                                            (mappedService) => {
                                                              if (
                                                                mappedService.id ===
                                                                service?.id
                                                              ) {
                                                                mappedService.schedule_type =
                                                                  value?.value || null;
                                                                // validation: required
                                                                if (!value?.value) {
                                                                  mappedService.scheduleTypeError = "required";
                                                                } else {
                                                                  mappedService.scheduleTypeError = "";
                                                                }
                                                              }
                                                              return mappedService;
                                                            }
                                                          );
                                                          return specialty;
                                                        }
                                                      )
                                                    );
                                                  }}
                                                  required
                                                />
                                                {service.scheduleTypeError && (
                                                  <div className="text-red fweight-600 mt-1">
                                                    {inputsValidations.required}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                            <div className="mb-3">
                                              <div className="d-flex align-items-center gap-2">
                                                <div className="d-flex align-items-center">
                                                  <div className="text-dark font-medium">
                                                    {
                                                      branches.addBranch
                                                        .specialtiesAndServices
                                                        .cancellationWindow
                                                    }
                                                    <span className="err-asterisk"> * </span>
                                                  </div>
                                                  <div className="ms-2">
                                                    <Tooltip
                                                      title={
                                                        <span className="fsize-12">
                                                          {
                                                            branches.addBranch
                                                              .specialtiesAndServices
                                                              .cancellationWindowTooltip
                                                          }
                                                        </span>
                                                      }
                                                      content={
                                                        <span className="text-bg-primary-mid fsize-14 font-reguler">
                                                          <InfoOutlined
                                                            size={20}
                                                            style={{
                                                              color: "#D19985",
                                                              cursor: "default",
                                                              transform: "translateY(-1px)",
                                                            }}
                                                          />
                                                        </span>
                                                      }
                                                    />
                                                  </div>
                                                </div>
                                                <div className="d-flex align-items-center">
                                                  <Input
                                                    id="cancellationWindowHours"
                                                    name="cancellationWindowHours"
                                                    type="text"
                                                    required
                                                    placeholder={
                                                      branches.addBranch
                                                        .specialtiesAndServices
                                                        .cancellationWindowPlaceholder
                                                    }
                                                    value={
                                                      service.cancellation_window_hours || ""
                                                    }
                                                    inputWrapperClass="mb-0"
                                                    labelClassName="d-none"
                                                    onChange={(value) => {
                                                      if (
                                                        NUMBERS_REGEX.test(value) ||
                                                        !value
                                                      ) {
                                                        setAddedSepacialtyWithServices(
                                                          addedSepacialtyWithServices.map(
                                                            (specialty) => {
                                                              specialty.services?.map(
                                                                (mappedService) => {
                                                                  if (
                                                                    mappedService.id ===
                                                                    service?.id
                                                                  ) {
                                                                    mappedService.cancellation_window_hours =
                                                                      value;
                                                                  // validation: positive int required (> 0)
                                                                  const trimmed = (value || "").trim();
                                                                  if (!trimmed) {
                                                                    mappedService.cancellationWindowHoursError = "required";
                                                                  } else {
                                                                    const numValue = parseInt(trimmed, 10);
                                                                    if (Number.isNaN(numValue) || numValue <= 0) {
                                                                      mappedService.cancellationWindowHoursError = "required";
                                                                    } else {
                                                                      mappedService.cancellationWindowHoursError = "";
                                                                    }
                                                                  }
                                                                  }
                                                                  return mappedService;
                                                                }
                                                              );
                                                              return specialty;
                                                            }
                                                          )
                                                        );
                                                      }
                                                    }}
                                                  />
                                                  <p className="text-gray fsize-16 mx-2 mb-2">
                                                    {
                                                      branches.addBranch.specialtiesAndServices
                                                        .hours
                                                    }
                                                  </p>
                                                </div>
                                              </div>
                                              {service.cancellationWindowHoursError && (
                                                <div className="text-red fweight-600 mt-1">
                                                  {inputsValidations.required}
                                                </div>
                                              )}
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </>
                                  )}
                                </div>
                                {service.editMood === true && (
                                  <div className="d-flex ms-auto gap-2 justify-content-end px-4 mb-4">
                                    {/* <Button /> */}
                                    <Button
                                      onClick={() => {
                                        setAddedSepacialtyWithServices(
                                          addedSepacialtyWithServices.map(
                                            (specialty) => {
                                              specialty.services?.map(
                                                (mappedService) => {
                                                  if (
                                                    mappedService.id ===
                                                    service?.id
                                                  ) {
                                                    service.editMood = false;
                                                  }
                                                  return mappedService;
                                                }
                                              );
                                              return specialty;
                                            }
                                          )
                                        );
                                      }}
                                      outlined
                                      color={"info"}
                                      type="button"
                                      label={shared.cancel}
                                      labelClass="fsize-16 text-gray py-1"
                                    />
                                    <Button
                                      onClick={() => {
                                        let editedData = {};
                                        let updatedSpecialty =
                                          addedSepacialtyWithServices?.find(
                                            (item) => item.id === specialty.id
                                          );
                                        let updatedService =
                                          updatedSpecialty.services?.find(
                                            (item) => item.id === service.id
                                          );
                                        editedData = {
                                          service_id: updatedService.service_id,
                                          id: updatedService.id,
                                          currency_id:
                                            currencyOptionsList?.find(
                                              (currency) =>
                                                currency.id ===
                                                  updatedService.currency_id ||
                                                currency.id === 1
                                            ).id,
                                          fees_from:
                                            updatedService.details.feesRange
                                              .from,
                                          // For multi_session, set fees_to to same as fees_from
                                          fees_to:
                                            updatedService.service_type === "multi_session"
                                              ? updatedService.details.feesRange.from
                                              : updatedService.details.feesRange.to,
                                          duration_mins:
                                            updatedService.details.duration,
                                          // description_en: updatedService.details.description,
                                          // description_ar: updatedService.details.description,
                                          description_en:
                                            updatedService.details.descriptionEN.value.trim(),
                                          description_ar:
                                            updatedService.details.descriptionAR.value.trim(),
                                        };
                                        if (
                                          updatedService.service_type ===
                                          "multi_session"
                                        ) {
                                          editedData.sessions_count =
                                            updatedService.sessions_count
                                              ? parseInt(
                                                  updatedService.sessions_count,
                                                  10
                                                )
                                              : null;
                                          editedData.expiry_weeks =
                                            updatedService.expiry_weeks
                                              ? parseInt(
                                                  updatedService.expiry_weeks,
                                                  10
                                                )
                                              : null;
                                          editedData.schedule_type =
                                            updatedService.schedule_type || null;
                                          editedData.cancellation_window_hours =
                                            updatedService.cancellation_window_hours
                                              ? parseInt(
                                                  updatedService.cancellation_window_hours,
                                                  10
                                                )
                                              : null;
                                        }
                                        dispatch(
                                          editBranchServicesRequest({
                                            id: editedData.id,
                                            data: editedData,
                                          })
                                        );
                                        dispatch(getBranchServicesResponse([]));
                                        editedData = {};
                                        setAddedSepacialtyWithServices(
                                          addedSepacialtyWithServices.map(
                                            (specialty) => {
                                              specialty.services?.map(
                                                (mappedService) => {
                                                  if (
                                                    mappedService.id ===
                                                    service?.id
                                                  ) {
                                                    service.editMood = false;
                                                  }
                                                  return mappedService;
                                                }
                                              );
                                              return specialty;
                                            }
                                          )
                                        );

                                        // let valid = true;
                                        // // check manual validation
                                        // setAddedSepacialtyWithServices(
                                        //   addedSepacialtyWithServices.map((specialty) => {
                                        //     specialty.services?.map((service) => {
                                        //       if (service.editMood) {
                                        //         if (!service.details.feesRange.from) {
                                        //           valid = false;
                                        //           service.details.feesRange.hasErrors = true;
                                        //           if (!service.details.feesRange.errors.includes('fromIsRequired')) {
                                        //             service.details.feesRange.errors.push('fromIsRequired');
                                        //           }
                                        //         }
                                        //         if (!service.details.duration) {
                                        //           valid = false;
                                        //           service.details.hasErrors = true;
                                        //           if (!service.details.errors.includes('durationIsRequired')) {
                                        //             service.details.errors.push('durationIsRequired');
                                        //           }
                                        //         }
                                        //       }
                                        //       return service;
                                        //     });
                                        //     return specialty;
                                        //   })
                                        // );
                                        // // add all checked service with details to branch services Call API
                                        // if (valid) {
                                        //   let editedData = {};
                                        //   addedSepacialtyWithServices?.forEach((specialty) => {
                                        //     specialty.services?.forEach((service) => {
                                        //       if (service.editMood) {
                                        //         editedData = {
                                        //           service_id: service.service_id,
                                        //           id: service.id,
                                        //           currency_id: currencyOptionsList?.find(
                                        //             (currency) =>
                                        //               currency.id === service.currency_id || currency.id === 1
                                        //           ).id,
                                        //           fees_from: service.details.feesRange.from,
                                        //           fees_to: service.details.feesRange.to,
                                        //           duration_mins: service.details.duration,
                                        //           description_en: service.details.description,
                                        //           description_ar: service.details.description,
                                        //         };
                                        //       }
                                        //     });
                                        //   });
                                        //   dispatch(
                                        //     editBranchServicesRequest({
                                        //       id: editedData.id,
                                        //       data: editedData,
                                        //     })
                                        //   );
                                        //   dispatch(getBranchServicesResponse([]));
                                        //   editedData = {};
                                        //   setAddedSepacialtyWithServices(
                                        //     addedSepacialtyWithServices.map((specialty) => {
                                        //       specialty.services?.map((mappedService) => {
                                        //         if (mappedService.id === service?.id) {
                                        //           service.editMood = false;
                                        //         }
                                        //         return mappedService;
                                        //       });
                                        //       return specialty;
                                        //     })
                                        //   );
                                        //   setRenderEmpatyStateSection(true);
                                        //   setRenderAddedServiceSection(false);
                                        //   setRenderServicesSection(false);
                                        //   setTimeout(() => {
                                        //     setRenderEmpatyStateSection(false);
                                        //     setRenderAddedServiceSection(true);
                                        //   }, 500);
                                        // }
                                      }}
                                      type="button"
                                      // outlined
                                      // color={'info'}
                                      label={shared.save}
                                      labelClass="fsize-16 text-white py-1"
                                      disabled={isEditServiceSaveBtnDisabled(
                                        specialty.id,
                                        service.id
                                      )}
                                    />
                                  </div>
                                )}
                                {/* line */}
                                {i !== specialty?.services?.length - 1 && (
                                  <div className="line-separator-96 mx-auto"></div>
                                )}
                              </div>
                            );
                          })}
                        </>
                      }
                      arrowRotate={specialty?.isExpanded}
                      setArrowRotateValue={(value) => {
                        ArrowChange(value, specialty);
                      }}
                    />
                  </div>
                );
              })}
            </div>
            <div className="mt-4 py-4 d-flex justify-content-end gap-2">
              {/* <Button
                onClick={() => {
                  // go back to specialties section
                  updateServicesContent();
                  setRenderSpecialtiesSection(false);
                  setRenderServicesSection(true);
                  changeSubTitle('AddSpecialties');
                  changeServiceTitle(null);
                  setRenderAddedServiceSection(false);
                }}
                outlined
                type="button"
                color={'info'}
                label={shared.previous}
                labelClass="fsize-16 py-1"
              /> */}
              <Button
                onClick={() => {
                  isEditServiceTotalSaveBtnDisabled()
                    ? setOpenDoneModal(true)
                    : saveAndProcced();
                }}
                type="button"
                // label={parentProps?.location?.state?.cameFrom ? shared.save : shared.saveAndProcced}
                label={shared.done}
                labelClass="fsize-16 text-white py-1"
              />
            </div>
            <Modal
              open={openDeleteSpecilatyConfirm}
              handleClose={handleCloseDeleteSpecilatyConfirmModal}
              title={branches.addBranch.specialtiesAndServices.deleteSpecialty}
              contentClass="mb-5 pb-2 text-primary"
              content={
                <span>
                  {branches.addBranch.specialtiesAndServices.deleteSpecialtyMsg}
                  <div className="my-3">
                    <span className="text-secondary">
                      {branches.addBranch.specialtiesAndServices.note}:{" "}
                    </span>
                    {
                      branches.addBranch.specialtiesAndServices
                        .deletSpecialityNote
                    }
                  </div>
                </span>
              }
              confirmBtnTxt={shared.delete}
              maxWidth="xs"
              cancelBtnTxt={shared.cancel}
              isContentText={false}
              handleConfirm={handleDeleteSpecialty}
              handleCancel={handleCloseDeleteSpecilatyConfirmModal}
              modalClass="delete-speciialty-modal"
              actionsClass="container px-4"
              confirmBtnClass="btn-secondary fsize-14 text-white py-2 "
              cancelBtnClass="fsize-14 py-2"
            />
            <Modal
              open={openDeleteServiceConfirm}
              handleClose={handleCloseDeleteServiceConfirmModal}
              title={
                <span>
                  {branches.addBranch.specialtiesAndServices.deleteService}
                </span>
              }
              contentClass="mb-3 pb-2 text-primary"
              content={
                <span>
                  {branches.addBranch.specialtiesAndServices.deleteServiceMsg}
                  <div className="my-3">
                    <span className="text-secondary">
                      {branches.addBranch.specialtiesAndServices.note}:{" "}
                    </span>
                    {
                      branches.addBranch.specialtiesAndServices
                        .deleteServiceNote
                    }
                  </div>
                </span>
              }
              confirmBtnTxt={shared.delete}
              maxWidth="xs"
              cancelBtnTxt={shared.cancel}
              isContentText={false}
              handleConfirm={handleDeleteService}
              handleCancel={handleCloseDeleteServiceConfirmModal}
              modalClass="delete-service-modal"
              actionsClass="container px-4"
              confirmBtnClass="btn-secondary fsize-14 text-white py-2 "
              cancelBtnClass="fsize-14 py-2"
            />
            <Modal
              open={showDeactivateServicePopup}
              handleClose={handleCloseDeactivatePopup}
              title={
                <span>
                  {branches.addBranch.specialtiesAndServices.deactivateService}
                </span>
              }
              contentClass="mb-3 pb-2 text-primary"
              content={
                <span>
                  {
                    branches.addBranch.specialtiesAndServices
                      .deactivateServiceMsg
                  }
                  <div className="my-3">
                    <span className="text-secondary">
                      {branches.addBranch.specialtiesAndServices.note}:{" "}
                    </span>
                    {
                      branches.addBranch.specialtiesAndServices
                        .deactivateServiceNote
                    }
                  </div>
                </span>
              }
              confirmBtnTxt={shared.procced}
              maxWidth="xs"
              cancelBtnTxt={shared.cancel}
              isContentText={false}
              handleConfirm={handleConfirmDecativateService}
              handleCancel={handleCloseDeactivatePopup}
              modalClass="delete-service-modal"
              actionsClass="container px-4"
              confirmBtnClass="btn-secondary fsize-14 text-white py-2 "
              cancelBtnClass="fsize-14 py-2"
            />
            <Modal
              open={openDoneModal}
              handleClose={() => setOpenDoneModal(false)}
              title={
                branches.addBranch.specialtiesAndServices
                  .confirmAllServicesSavedTitle
              }
              contentClass="mb-5 pb-2 text-primary"
              content={
                <span>
                  {
                    branches.addBranch.specialtiesAndServices
                      .confirmAllServicesSavedContent
                  }
                </span>
              }
              isContentText={false}
              confirmBtnTxt={shared.done}
              maxWidth="xs"
              cancelBtnTxt={shared.cancel}
              handleConfirm={saveAndProcced}
              handleCancel={() => setOpenDoneModal(false)}
              modalClass="delete-speciialty-modal"
              actionsClass="container px-4"
              confirmBtnClass="btn-secondary fsize-14 text-white py-2 "
              cancelBtnClass="fsize-14 py-2"
            />
          </>
        ) : (
          !isLoading && (
            <div className="bg-white rounded-4 services-page d-flex justify-content-center align-items-center flex-column m-4 mt-0">
              <EmptyState
                subTitle={shared.noServicesAddedyet}
                ButtonLabel={
                  branches.addBranch.labels.addSepicialtiesAndServices
                }
                handleBtnAction={() => {
                  dispatch(getBranchResponse({}));
                  getSpecialties();
                  setNoAssgiendServicesOnSpecialtyAlert(false);
                  setActiveSection("specialties");
                  setRenderAddedServiceSection(false);
                  setIsAddSpecialtiesAndServicesBTNClicked(true);
                }}
              />
            </div>
          )
        )}
      </>
    );
  };

  const ArrowChange = (value, specialty) => {
    if (value) {
      handleExpandFuntion(value, specialty.id);
      getServicesBySpecialtyId(specialty.realSpecialtyId);
      assignAddedSpecialtyAndServicesFromViewBranchData();
      updateServicesContent();
    } else {
      handleExpandFuntion(value, specialty.id);
      getServicesBySpecialtyId(specialty.realSpecialtyId);
      assignAddedSpecialtyAndServicesFromViewBranchData(); //haya di ely bet8ayar el conttent al outer we haya kamanl aly bet5ali eldata te5tafy
      updateServicesContent();
    }
  };

  const saveAndProcced = () => {
    if (parentProps?.location?.state?.cameFrom) {
      history.push({
        pathname: ROUTE_PATHS.viewBranch.replace(":id", branchid),
        state: {
          setTabIndex: 1,
        },
      });
    } else {
      proceedToNextStep();
    }
  };

  return (
    <>
      <form
        noValidate
        onSubmit={handleSubmit}
        className="add-specialties-services-section"
      >
        <div className="px-2 px-md-5 bg-white rounded-4 py-4">
          <div className="row">
            <div className="col-12">
              {renderEmpatyStateSection && renderEmptyState()}{" "}
              {/*case 1 : empty state*/}
              {renderSpecialtiesSection && renderSpecialties()}{" "}
              {/*case 2 : add new specialty so listing all provider specialties and on click any one go to case 3 */}
              {renderServicesSection && renderServices()}{" "}
              {/*case 3 : rendering edit specialty so list all provider services on this specialty*/}
              {renderAddedServiceSection && viewAddedServices()}{" "}
              {/*case 4 : rendering branches specialties , services and edit mode of services */}
            </div>
          </div>
        </div>
      </form>
      <AddEditManualSpecialtyModal
        open={showAddEditManualSpecialtyModal}
        setOpen={setShowAddEditManualSpecialtyModal}
        setSelectedSpecialty={setSelectedManualAddedSpecialty}
        selectedSpecialty={selectedManualAddedSpecialty}
        onSuccess={() => setBtnClicked("listSpecialties")}
        categoryId={branchCategoryId || viewBranchDetails?.category?.id}
      />
      <DeleteManualAddedSpecialtyModal
        open={showDeleteManualAddedSpecialtyModal}
        setOpen={setShowDeleteManualAddedSpecialtyModal}
        selectedSpecialty={selectedManualAddedSpecialty}
        onSuccess={() => setBtnClicked("listSpecialties")}
      />
      <AddEditManualServiceModal
        open={showAddEditManualServiceModal}
        setOpen={setShowAddEditManualServiceModal}
        setSelectedService={setSelectedManualAddedService}
        selectedService={selectedManualAddedService}
        choosenSpecialtyId={choosenSpecialtyId}
        onSuccess={() => getServicesBySpecialtyId(choosenSpecialtyId)}
        allowMultiSessions={allowMultiSessions}
        serviceProviderId={serviceProviderId}
      />
      <DeleteManualAddedServiceModal
        open={showDeleteManualAddedServiceModal}
        setOpen={setShowDeleteManualAddedServiceModal}
        selectedService={selectedManualAddedService}
        onSuccess={() => getServicesBySpecialtyId(choosenSpecialtyId)}
      />
    </>
  );
};

export default AddServicesDetails;
